import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import Vas from '../Vas';
import '../css/Order.css';
import { ExtendedButton,TextField, Icon, SelectField,MessageBox,DateField,AutocompleteField,Checkbox,EmailField,IbanField, HoneyPot } from 'component-lib';
import { DateTimeHelper,CheckValues,CheckFields,Jump,CurrencyConverter } from 'utils-lib';
import { RequestAjaxClass, ConfirmationsModel, StreetsModel, Customer, Payment, OrderContractModel,AdditionalAddressesModel,Address,GenderModel } from 'models-lib';


var moment = require('moment');
moment().format();

var stepperIconActiveId = '';

let stepIdDataProtection = 4;
let stepIdCaptcha = 5;
let stepIdOverview = 6;

class OrderPopUp extends Component
{
    //#region Komponente
    constructor(props)
    {
        super(props);
        this.state = {};
        this.state.steps = 8;
        this.state.login = false;
        this.state.existConfirm = [];
        this.state.Files = [];
        this.tariff = JSON.parse(localStorage.getItem("Tariff"));
        this.state.CustomerOfAge = true;
        this.state.ConfirmationsRequired = false;
        this.state.CustomerEqualAccountOwner = true;

        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.Request2 = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);

        this.ConfirmationsModel = new ConfirmationsModel([this],null,this.Request);
        this.StreetsModelCustomer = new StreetsModel([this],"StreetsCustomer",this.Request);
        this.StreetsModelLegalGuardien = new StreetsModel([this],"StreetsLegalGuardien", this.Request);
        this.StreetsModelAccountOwner = new StreetsModel([this],"StreetsAccountOwner", this.Request);
        this.OrderModel = new OrderContractModel([this],null,this.Request);
        this.AdditionalAddressesModel = new AdditionalAddressesModel([this],null,this.Request2);

        this.Customer = new Customer();
        this.LegalGuardien = new Address();

        this.AccountOwner = new Customer();

        this.Payment = new Payment();

        this.updloadedFiles = 0;
        this.filesCount = 0;
        this.filesCountCur = 0;

        this.FileText = React.createRef();
        
        this.VerificationMonthRef = React.createRef();
        this.UploadCertificateRef = React.createRef();

        this.ConfigDataProtection = Vas.Config.DataProtection;

        // eslint-disable-next-line no-unused-expressions
        this.Request3 = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error)},null);
        this.GenderModel = new GenderModel([this], null, this.Request3);

        this.Request3.setAuth(false);
        this.Request3.setApiKey(Vas.ApiKey);
        this.Request3.setApiUrl(Vas.ApiUrl);

        this.GenderModel.GetGender();

        this.IconConfig = Vas.Config.ShowIconsOrButtons;
        this.UploadConfig = Vas.Config.DocumentUpload;
    }

    componentWillMount(){
        localStorage.removeItem("anonymous_token");
        localStorage.removeItem('vas_token');
    }

    componentDidMount(){
       
      this.LegalGuardien.AddressType.Id = 11;

      this.Request.setAuth(false);
      this.Request.setApiKey(Vas.ApiKey);
      this.Request.setApiUrl(Vas.ApiUrl);

      this.Request2.setAuth(false);
      this.Request2.setApiKey(Vas.ApiKey);
      this.Request2.setApiUrl(Vas.ApiUrl);

      Jump.jump(this.state.steps,1,1);

        let reqFields = [{Key:this.refs.name,Index:1,Step:1},
                        {Key:this.refs.firstName,Index:2,Step:1},
                        {Key:this.refs.dateOfBirth,Index:3,Step:1},
                        {Key:this.refs.email,Index:5,Step:1},
                        {Key:this.refs.emailRepeat,Index:6,Step:1}, 
                        {Key:this.refs.zip,Index:8,Step:2},
                        {Key:this.refs.city,Index:9,Step:2}, 
                        {Key:this.refs.street,Index:10,Step:2}, 
                        {Key:this.refs.houseNumber,Index:11,Step:2},
                         
                        {Key:this.refs.accountOwnerName,Index:12,Step:3}, 
                        {Key:this.refs.accountOwnerFirstName,Index:13,Step:3},
                        {Key:this.refs.dateOfBirthAccountOwner,Index:14,Step:3},  
                        {Key:this.refs.iban,Index:20,Step:3},
                        {Key:this.refs.bic,Index:21,Step:3}];

        let reqFieldsLegalGuardien = [{Key:this.refs.nameLegalGuardien,Index:23,Step:4}, 
                                      {Key:this.refs.firstNameLegalGuardien,Index:24,Step:4},
                                      {Key:this.refs.dateOfBirthLegalGuardien,Index:25,Step:4},
                                      //{Key:this.refs.emailLegalGuardien,Index:16,Step:4},
                                      //{Key:this.refs.emailRepeatLegalGuardien,Index:17,Step:4}, 
                                      {Key:this.refs.zipLegalGuardien,Index:29,Step:5}, 
                                      {Key:this.refs.cityLegalGuardien,Index:30,Step:5}, 
                                      {Key:this.refs.streetLegalGuardien,Index:31,Step:5}, 
                                      {Key:this.refs.houseNumberLegalGuardien,Index:32,Step:5}
                                      ];

        let reqFieldsAccountOwner = [{Key: this.refs.zipAccountOwner,Index:16,Step:3},
                                      {Key:this.refs.cityAccountOwner,Index:17,Step:3},
                                      {Key:this.refs.streetAccountOwner,Index:18,Step:3}, 
                                      {Key:this.refs.houseNumberAccountOwner,Index:19,Step:3}
                                    ];

        let reqSelectFieldsAccountOwner = [{Key:this.refs.genderAccountOwner, Index:15, Step : 3 }];

        let reqCheckBox = [{Key:this.refs.AcceptPaymentTerms,Index:22,Step:3}];

        if(this.ConfigDataProtection.Order === true){
          reqCheckBox.push({Key:this.refs.AcceptPrivacyTariffTerms,Index:33,Step:stepIdDataProtection});
        }

        
        if(this.tariff){
          localStorage.setItem("SelectedProductId", this.tariff[0].IdTicket);
          this.ConfirmationsModel.GetConfirmationsByTicketId(this.tariff[0].IdTicket);
        }
        
        
        let rqAge = 0;
        let maxAge = 0;
        let contractStart = moment();

        if(this.tariff){
          if(this.tariff[0]){
            if(this.tariff[0].RequiredAge){
              rqAge = this.tariff[0].RequiredAge;
            }
            if(this.tariff[0].MaximumAge){
              maxAge = this.tariff[0].MaximumAge;
            }
          }
          
          if(this.tariff[1]){
            if(this.tariff[1].ContractStart){
              contractStart = DateTimeHelper.StringToDate(this.tariff[1].ContractStart,true,localStorage.getItem('vas_language')) ;
            }
          }
        }

        
        if(rqAge !== 0 ){
          let minBDay = moment([contractStart.year(),contractStart.month(),contractStart.date()]).subtract(rqAge, 'years');
          this.refs.dateOfBirth.setState({ MaxValue: moment([minBDay.year(),minBDay.month(), minBDay.date()]),
            FalseMaxDateText : Vas.Resources.Labels["RequiredAge1"] + rqAge + Vas.Resources.Labels["RequiredAge2"]
          });

          document.getElementById('HintRequiredAge').innerHTML = Vas.Resources.Labels["RequiredAge1"] + rqAge + Vas.Resources.Labels["RequiredAge2"];
        }else{
          document.getElementById('HintRequiredAge').innerHTML = '';
        }

        if(maxAge !== 0){
          let maxBDay = moment([contractStart.year(),contractStart.month(),contractStart.date()]).subtract(maxAge, 'years');
          this.refs.dateOfBirth.setState({ MinValue: moment([maxBDay.year(),maxBDay.month(), maxBDay.date()]),
            FalseMinDateText: Vas.Resources.Labels["RequiredAge3"] + maxAge + Vas.Resources.Labels["RequiredAge2"]});

          document.getElementById('HintMaxAge').innerHTML = Vas.Resources.Labels["RequiredAge3"] + maxAge + Vas.Resources.Labels["RequiredAge2"];
        }else{
          document.getElementById('HintMaxAge').innerHTML = '';
        }


        this.setState(
          { requiredFields:reqFields, 
            requiredSelectField:[{Key:this.refs.gender,Index:4,Step:1}],
            requiredCeckBox:reqCheckBox,
            allCertificates:true,
            requiredFieldsLegalGuardien : reqFieldsLegalGuardien,
            requiredSelectFieldLegalGuardien : [{Key:this.refs.genderLegalGuardien,Index:26,Step:4}],
            requiredFieldsAccountOwner : reqFieldsAccountOwner,
            requiredSelectFieldsAccountOwner : reqSelectFieldsAccountOwner
          },()=>{ 
                for (let i=0; i<this.state.requiredFields.length; i++){
                    if (this.state.requiredFields[i].Key.props.IsRequired){
                        this.state.requiredFields[i].Key.setState({ Label:this.state.requiredFields[i].Key.props.Label+"*" });
                    }
                }

                for (let i=0; i<this.state.requiredSelectField.length; i++){
                    if (this.state.requiredSelectField[i].Key.props.IsRequired){
                        this.state.requiredSelectField[i].Key.setState({ Label:this.state.requiredSelectField[i].Key.props.Label+"*" });
                    }
                }

                this.setContractData();
        });

        this.LogoClick();
        this.FontSizeClick();
    }

    Update(observer){
      let me = this;
      this.setState({},()=>{
        if(observer === "ConfirmationsByTicketId"){
          $("#LoadingIconPopUp").removeClass().addClass('hide');
          if (me.ConfirmationsModel.Confirmations.length > 0){
            let reFields = this.state.requiredFields;
            reFields = this.changeRequiredFieldsIndex(reFields,this.state.CustomerOfAge,true);
            let reCheckBox = this.state.requiredCeckBox;
            reCheckBox = this.changeRequiredFieldsIndex(reCheckBox,this.state.CustomerOfAge,true);

            me.setState({ConfirmationsRequired : true, 
              RequiredConfirmations : me.ConfirmationsModel.Confirmations,
              requiredFields : reFields,
              requiredCeckBox : reCheckBox},()=>{
              me.getConfirmationFields(me.ConfirmationsModel.Confirmations);
            });
          } else {
            let reFields = this.state.requiredFields;
            reFields = this.changeRequiredFieldsIndex(reFields,this.state.CustomerOfAge,false);
            let reCheckBox = this.state.requiredCeckBox;
            reCheckBox = this.changeRequiredFieldsIndex(reCheckBox,this.state.CustomerOfAge,false);

            me.setState({ allCertificates: true, 
                ConfirmationsRequired : false,
                requiredFields : reFields,
                requiredCeckBox : reCheckBox });
          }
        }
        else if(observer === "StreetsCustomer"){
          let streets = [];
          if (me.StreetsModelCustomer.Streets)
          {
              streets = me.StreetsModelCustomer.Streets;
          }
          me.refs.street.setState({ Data: streets, Icon :'',placeholder:'' });
        }
        else if(observer === "StreetsLegalGuardien"){
          let streets = [];
          if (me.StreetsModelLegalGuardien.Streets)
          {
              streets = me.StreetsModelLegalGuardien.Streets;
          }
          me.refs.streetLegalGuardien.setState({ Data: streets, Icon :'',placeholder:'' });
        }
        else if(observer === "StreetsAccountOwner"){
          let streets = [];
          if (me.StreetsModelAccountOwner.Streets)
          {
              streets = me.StreetsModelAccountOwner.Streets;
          }
          me.refs.streetAccountOwner.setState({ Data: streets, Icon :'',placeholder:'' });
        }
        else if(observer === "Contracts" || observer === "ContractsWithConfirmations"){
          
          if (me.OrderModel.Response.Contract.IdCustomer.length > 0){
            let customerId = me.OrderModel.Response.Contract.IdCustomer;
            localStorage.setItem("CustomerId", customerId);
            localStorage.setItem("ContractNumber", me.OrderModel.Response.Contract.ContractNumber);

            localStorage.setItem('ContractOverviewTariffPointFromAtg', me.OrderModel.Response.ContractConnection.AtgFrom);
            localStorage.setItem('ContractOverviewTariffPointToAtg', me.OrderModel.Response.ContractConnection.AtgTo);

            if(this.state.CustomerOfAge === false){
              me.AdditionalAddressesModel.Address = this.LegalGuardien;
              me.AdditionalAddressesModel.SetNewAdditionalAddressByCustomerId(customerId);
            }else{
              ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
              //Vas.clearLocalStorage();
              Vas.GetView("OrderSuccess",[],false);
            }
          }
        }
        else if(observer === "NewAdditionalAddress"){
          ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
          Vas.GetView("OrderSuccess",[],false);
        }
        else if(observer === "EmailChecked"){
          this.setEditable();
        }
        else if(observer === "Gender"){
          let genderSelection = []
      
          if(this.GenderModel.Gender.length > 0){

            let genderArray = this.GenderModel.Gender;

            if(genderArray.length === 2) {
              genderSelection = [{ Key: genderArray[0], Display: Vas.Resources.Labels["Male"] },{ Key: genderArray[1], Display: Vas.Resources.Labels["Female"] }];
            } else if(genderArray.length === 3){
              genderSelection = [{ Key: genderArray[0], Display: Vas.Resources.Labels["Male"] },{ Key: genderArray[1], Display: Vas.Resources.Labels["Female"] },{ Key: genderArray[2], Display: 'divers' }];
            }
          }
          this.setState({GenderValues : genderSelection});
          this.refs.gender.setState({Data:genderSelection});
        }

      })
    }

    jump(id, stepId)//springe zu einem anderen Stepperfeld; stepId = Id des Steps, dessen Button geklickt wurde
    {
      let curId = Number(id);
      let curStepId = Number(stepId);

      if((curId === 6 && curStepId === 5) || 
        (curId === 6 && (curStepId === undefined || isNaN(curStepId))) || 
        (curId === 7 && (curStepId === undefined || isNaN(curStepId))) || 
        (curId === 8 && (curStepId === undefined || isNaN(curStepId))) ||
        (curId === 9 && (curStepId=== undefined || isNaN(curStepId) )) ||
        (curId === 5 && curStepId=== 4) ||
        (curId === 5 && (curStepId === undefined || isNaN(curStepId)))) {
          //Update Persönliche Daten
          this.updatePersonalData();       
      }

      stepperIconActiveId =Jump.jump(this.state.steps,curId,curStepId,stepperIconActiveId);

      //Hier die ersten Controls entsptechend der übergebenen curId & curStepId setzen
      if((curId === 1 && curStepId === 2) || (curId === 1 && curStepId === 0)){
        if(document.getElementById("Name1") != null){
          document.getElementById("Name1").focus();
        }
      }

      if((curId === 2 && curStepId === 3) || (curId === 2 && curStepId === 0)){
        if(document.getElementById("Zip") != null){
          document.getElementById("Zip").focus();
        }
      }

      if((curId === 3 && curStepId === 4) || (curId === 3 && curStepId === 0) || (curId === 5 && curStepId === 0)){
        if(document.getElementById("accountOwnerName") != null){
          document.getElementById("accountOwnerName").focus();
        }

        if(document.getElementById("btoChoose_1") != null){
          document.getElementById("btoChoose_1").focus();
        }

        if(document.getElementById("ZipLegalGuardien") != null){
          document.getElementById("ZipLegalGuardien").focus();
        }
      }

      if((curId === 4 && curStepId === 5) || (curId === 4 && curStepId === 0)){
        if(document.getElementById("ceckboxMarketingMail") != null){
          document.getElementById("ceckboxMarketingMail").focus();
        }

        if(document.getElementById("Name1LegalGuardien") != null){
          document.getElementById("Name1LegalGuardien").focus();
        }
      }
      this.LogoClick();
      this.FontSizeClick();
    }

    updatePersonalData(){

      //ContractData
      document.getElementById("ContractData_TicketName").innerText = this.tariff[0].TicketName;
      document.getElementById("ContractData_ContractStart").innerText = DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(this.tariff[1].ContractStart,true,localStorage.getItem('vas_language')));
      //Bei SeniorenTicket, JungeLeuteTicket, AzubiTicket Sachsen und Bildungsticket soll kein Von und Nach abgezeigt werden
      //Prüfung über TicketIdent
      if(this.tariff[0].TicketIdent == "01-37-02" || 
         this.tariff[0].TicketIdent == "01-45-02" || 
         this.tariff[0].TicketIdent == "01-43-02" || 
         this.tariff[0].TicketIdent == "01-47-02"){
        document.getElementById("ContractData_DescriptionLongFromHeadline").style.display = 'none';
        document.getElementById("ContractData_DescriptionLongFrom").style.display = 'none';
        document.getElementById("ContractData_DescriptionLongToHeadline").style.display = 'none';
        document.getElementById("ContractData_DescriptionLongTo").style.display = 'none';
      } else {
        if(this.tariff[0].IdMatrixFix == ''){
          document.getElementById("ContractData_DescriptionLongFrom").innerText = this.tariff[1].DescriptionLong;
          document.getElementById("ContractData_DescriptionLongTo").innerText = this.tariff[2].DescriptionLong;
        } else {
          document.getElementById("ContractData_DescriptionLongFromHeadline").style.display = 'none';
          document.getElementById("ContractData_DescriptionLongFrom").style.display = 'none';
          document.getElementById("ContractData_DescriptionLongToHeadline").style.display = 'none';
          document.getElementById("ContractData_DescriptionLongTo").style.display = 'none';
        }
      }

      if(this.tariff[0].TicketIdent == "01-35-02" || 
      this.tariff[0].TicketIdent == "01-38-02" ||
      this.tariff[0].TicketIdent == "01-39-02" ||
      this.tariff[0].TicketIdent == "01-40-02"){
        if((this.tariff[0].PriceLevel == "1 Zone" || 
        this.tariff[0].PriceLevel == "2 Zonen" || 
        this.tariff[0].PriceLevel == "kleiner Stadtverkehr") && 
        (this.tariff[0].TzViaText == "direkt"|| 
        this.tariff[0].TzViaText == "direkter Weg")){
          document.getElementById("ContractData_TzViaLabel").style.display = 'none';
          document.getElementById("ContractData_TzViaText").style.display = 'none';
        } else{
          document.getElementById("ContractData_DescriptionLongFromHeadline").style.display = 'none';
          document.getElementById("ContractData_DescriptionLongFrom").style.display = 'none';
          document.getElementById("ContractData_DescriptionLongToHeadline").style.display = 'none';
          document.getElementById("ContractData_DescriptionLongTo").style.display = 'none';

          if(this.tariff[0].IdendTzVia == ''){
            document.getElementById("ContractData_TzViaLabel").style.display = 'none';
            document.getElementById("ContractData_TzViaText").style.display = 'none';
          } else{
            document.getElementById("ContractData_TzViaText").innerText = this.tariff[0].TzViaText + " (" + this.tariff[0].PriceLevel + ")";
          }
        }
      } else {
        if(this.tariff[0].IdendTzVia == ''){
          document.getElementById("ContractData_TzViaLabel").style.display = 'none';
          document.getElementById("ContractData_TzViaText").style.display = 'none';
        } else{
          document.getElementById("ContractData_TzViaText").innerText = this.tariff[0].TzViaText + " (" + this.tariff[0].PriceLevel + ")";
        }
      }
      document.getElementById("ContractData_Price").innerText = CurrencyConverter.Cast( this.tariff[0].Price, localStorage.getItem("vas_language") ,2);
      document.getElementById("ContractData_ContractEnd").innerText = this.tariff[0].ContractEnd == null ? "" : DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(this.tariff[0].ContractEnd,true,localStorage.getItem('vas_language')));

      document.getElementById("ContractData_PriceLevel").innerText = this.tariff[0].PriceLevel;

      //PersonalData
      document.getElementById("PersonalData_Name1").innerText = this.Customer.Name1;
      document.getElementById("PersonalData_Name2").innerText = this.Customer.Name2;

      let cur = DateTimeHelper.StringToDate($("#DateOfBirth").val(),false,localStorage.getItem('vas_language'));
      document.getElementById("PersonalData_DateOfBirth").innerText = $("#DateOfBirth").val() == "" ? "" : moment([cur.year(),cur.month(),cur.date()]).format("DD.MM.YYYY");
      document.getElementById("PersonalData_Gender").innerText = this.Customer.Gender;

      document.getElementById("PersonalData_Email").innerText = this.Customer.Email;
      document.getElementById("PersonalData_Phone").innerText = this.Customer.Phone;

      //AddressData
      document.getElementById("AddressData_Zip").innerText = this.Customer.PostCode == "" ? $("#Zip").val() : this.Customer.PostCode;
      document.getElementById("AddressData_Place").innerText = this.Customer.City == "" ? $("#City").val() : this.Customer.City;

      document.getElementById("AddressData_Street").innerText = this.Customer.Street == "" ? $("#Street").val() : this.Customer.Street;

      document.getElementById("AddressData_HouseNumber").innerText = this.Customer.HouseNumber == "" ? $("#HouseNumber").val() : this.Customer.HouseNumber;
      document.getElementById("AddressData_HouseNumberAddition").innerText = this.Customer.HouseNumberAddition == "" ? $("#HouseNumberAddition").val() : this.Customer.HouseNumberAddition;

      document.getElementById("AddressData_AddressAddition").innerText = this.Customer.Name3;

      //Daten gesetzlicher Vertreter
      if(this.state.CustomerOfAge == false){

        //PersonalData Legaluardian
        document.getElementById("PersonalDataLegalGuardian_Name1").innerText = this.LegalGuardien.Name1;
        document.getElementById("PersonalDataLegalGuardian_Name2").innerText = this.LegalGuardien.Name2;

        let cur = DateTimeHelper.StringToDate($("#DateOfBirthLegalGuardien").val(),false,localStorage.getItem('vas_language'));
        document.getElementById("PersonalDataLegalGuardian_DateOfBirth").innerText = $("#DateOfBirthLegalGuardien").val() == "" ? "" : moment([cur.year(),cur.month(),cur.date()]).format("DD.MM.YYYY");
        document.getElementById("PersonalDataLegalGuardian_Gender").innerText = this.LegalGuardien.Gender;

        document.getElementById("PersonalDataLegalGuardian_Email").innerText = this.LegalGuardien.Email;
        document.getElementById("PersonalDataLegalGuardian_Phone").innerText = this.LegalGuardien.Phone == undefined ? "" : this.LegalGuardien.Phone;

        //AddressData LegalGuardian
        document.getElementById("AddressDataLegalGuardian_Zip").innerText = this.LegalGuardien.Zip == "" || this.LegalGuardien.Zip == undefined ? $("#ZipLegalGuardien").val() : this.LegalGuardien.Zip;
        document.getElementById("AddressDataLegalGuardian_Place").innerText = this.LegalGuardien.City == "" || this.LegalGuardien.City == undefined ? $("#CityLegalGuardien").val() : this.LegalGuardien.City;

        document.getElementById("AddressDataLegalGuardian_Street").innerText = this.LegalGuardien.Street == "" || this.LegalGuardien.Street == undefined ? $("#StreetLegalGuardien").val() : this.LegalGuardien.Street;

        document.getElementById("AddressDataLegalGuardian_HouseNumber").innerText = this.LegalGuardien.HouseNumber == "" || this.LegalGuardien.HouseNumber == undefined ? $("#HouseNumberLegalGuardien").val() : this.LegalGuardien.HouseNumber;
        document.getElementById("AddressDataLegalGuardian_HouseNumberAddition").innerText = this.LegalGuardien.HouseNumberAddition == "" || this.LegalGuardien.HouseNumberAddition == undefined ? $("#HouseNumberAdditionLegalGuardien").val() : this.LegalGuardien.HouseNumberAddition;

        document.getElementById("AddressDataLegalGuardian_AddressAddition").innerText = this.LegalGuardien.Name3 == undefined ? "" : this.LegalGuardien.Name3;     
      }

      if(this.state.CustomerEqualAccountOwner === false){
        document.getElementById("AddressDataAccountOwner_Gender").innerText = this.AccountOwner.Gender;
        document.getElementById("AddressDataAccountOwner_Zip").innerText = this.AccountOwner.Zip == "" || this.AccountOwner.Zip == undefined ? $("#ZipAccountOwner").val() : this.AccountOwner.Zip;
        document.getElementById("AddressDataAccountOwner_Place").innerText = this.AccountOwner.City == "" || this.AccountOwner.City == undefined ? $("#CityAccountOwner").val() : this.AccountOwner.City;

        document.getElementById("AddressDataAccountOwner_Street").innerText = this.AccountOwner.Street == "" || this.AccountOwner.Street == undefined ? $("#StreetAccountOwner").val() : this.AccountOwner.Street;

        document.getElementById("AddressDataAccountOwner_HouseNumber").innerText = this.AccountOwner.HouseNumber == "" || this.AccountOwner.HouseNumber == undefined ? $("#HouseNumberAccountOwner").val() : this.AccountOwner.HouseNumber;
        document.getElementById("AddressDataAccountOwner_HouseNumberAddition").innerText = this.AccountOwner.HouseNumberAddition == "" || this.AccountOwner.HouseNumberAddition == undefined ? $("#HouseNumberAdditionAccountOwner").val() : this.AccountOwner.HouseNumberAddition;

        document.getElementById("AddressDataAccountOwner_AddressAddition").innerText = this.AccountOwner.Name3 == undefined ? "" : this.AccountOwner.Name3;
      }
      //PaymentData
      document.getElementById("PaymentData_DepositorName").innerText = this.AccountOwner.Name1 == undefined ? "" : this.AccountOwner.Name1;
      document.getElementById("PaymentData_DepositorFirstname").innerText = this.AccountOwner.Name2 == undefined ? "" : this.AccountOwner.Name2;

      document.getElementById("PaymentData_Iban").innerText = this.Payment.Iban == undefined ? "" : this.Payment.Iban;

      document.getElementById("PaymentData_Bic").innerText = this.Payment.Bic == undefined ? "" : this.Payment.Bic;

      document.getElementById("PaymentData_NameOfBank").innerText = this.Payment.BankName == undefined ? "" : this.Payment.BankName;

    }

    Close(){
        ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
    }

    changeRequiredFieldsIndex(reqFields,ofAge,verification){
      for(let i = 0; i<reqFields.length; i++){
        if(reqFields[i].Index && reqFields[i].Step){
          switch (reqFields[i].Index) {
            case 32:
                if(ofAge === true && verification === true){
                  reqFields[i].Step = 4;
                }
                if(ofAge === false && verification === true){
                  reqFields[i].Step = 6;
                }
                if(ofAge === true && verification === false){
                  reqFields[i].Step = 3;
                }
                if(ofAge === false && verification === false){
                  reqFields[i].Step = 5;
                }
                
              break;
            case 33:
            //case 23:
            //case 24:
            //case 25:
            //case 26:
              if(ofAge === true && verification === true){
                reqFields[i].Step = 5;
              }
              if(ofAge === false && verification === true){
                reqFields[i].Step = 7;
              }
              if(ofAge === true && verification === false){
                reqFields[i].Step = 4;
              }
              if(ofAge === false && verification === false){
                reqFields[i].Step = 6;
              }
              break;
            /*case 27:
              if(ofAge === true && verification === true){
                reqFields[i].Step = 6;
              }
              if(ofAge === false && verification === true){
                reqFields[i].Step = 8;
              }
              if(ofAge === true && verification === false){
                reqFields[i].Step = 5;
              }
              if(ofAge === false && verification === false){
                reqFields[i].Step = 7;
              }
              break;*/
            case 34:
              if(ofAge === true && verification === true){
                reqFields[i].Step = 5;
              }
              if(ofAge === false && verification === true){
                reqFields[i].Step = 7;
              }
              if(ofAge === true && verification === false){
                reqFields[i].Step = 4;
              }
              if(ofAge === false && verification === false){
                reqFields[i].Step = 6;
              }
              break;
            default:
              break;
          }
        }
      }
      return reqFields
    }

    setMarketingPhone(marketing){
      let reqFields = this.state.requiredFields;
      if(marketing === true){
        reqFields.push({Key:this.refs.phone,Index:7,Step:1});
        this.refs.phone.setState({ Label:this.refs.phone.props.Label+"*" , isrequired : true});
      }else{
        let idx = -1;
        for(let i = 0; i< reqFields.length; i++){
          if(reqFields[i].Index && reqFields[i].Step){
            if(reqFields[i].Index === 7 && reqFields[i].Step === 1){
              idx = i;
            }
          }
        }
        if(idx > -1){
          reqFields.splice(idx,1);
          this.refs.phone.setState({ Label:this.refs.phone.props.Label , isrequired : false});
        }
      }
      this.setState({requiredFields : reqFields});
    }

    checkAccountOwner(){
      if(this.AccountOwner.Name1.length > 0 && this.AccountOwner.Name2.length > 0 && this.AccountOwner.DateOfBirth.length > 0){
        if(this.AccountOwner.Name1 === this.Customer.Name1 
          && this.AccountOwner.Name2 === this.Customer.Name2 
          && DateTimeHelper.StringToDate(this.AccountOwner.DateOfBirth,true,localStorage.getItem('vas_language')).isSame(DateTimeHelper.StringToDate(this.Customer.DateOfBirth,true,localStorage.getItem('vas_language')),'day') )
          {
            this.setState({CustomerEqualAccountOwner:true});
          }else {
            this.setState({CustomerEqualAccountOwner:false},()=>{
              
              this.setState({
                requiredFieldsAccountOwner:[{Key: this.refs.zipAccountOwner,Index:16,Step:3},
                  {Key:this.refs.cityAccountOwner,Index:17,Step:3},
                  {Key:this.refs.streetAccountOwner,Index:18,Step:3}, 
                  {Key:this.refs.houseNumberAccountOwner,Index:19,Step:3}
                ],
                requiredSelectFieldsAccountOwner : [{Key:this.refs.genderAccountOwner, Index:15, Step : 3 }]
              });
            });
          }
      }else{
        this.setState({CustomerEqualAccountOwner:true});
      }
    }

    setContractData(){
      if(localStorage.getItem("ContractData")){
        let result = JSON.parse(localStorage.getItem("ContractData"));
        if(result.length === 4){
          this.Customer = result[0];
          this.LegalGuardien = result[1];

          this.AccountOwner = result[2];
          this.Payment = result[3];

          //#region Customer
          //PersonalData
          document.getElementById("Name1").value = this.Customer.Name1;
          document.getElementById("Name2").value = this.Customer.Name2;
          if(document.getElementById("Name1").value.length > 0 && document.getElementById("Name2").value.length > 0){
            let cur = DateTimeHelper.StringToDate(this.Customer.DateOfBirth,true,localStorage.getItem('vas_language'));
            document.getElementById("DateOfBirth").value = moment([cur.year(),cur.month(),cur.date()]).format("DD.MM.YYYY");
            this.checkOfAge($("#DateOfBirth").val());
            this.ConfirmationsModel.GetConfirmationsByTicketId(this.tariff[0].IdTicket,this.Customer.DateOfBirth);
          }     

          let idx = 0;

          if(localStorage.getItem("Gender")!= ''){

            let selData = localStorage.getItem("Gender").split(',');
            for(let i = 0; i < selData.length; i++){
              if(selData[i] === this.Customer.Gender){
                idx = i;
              }
            }
          }

          document.getElementById("Gender").selectedIndex = idx + 1;

          document.getElementById("Email").value = this.Customer.Email;
          this.refs.email.checkEmail('Email');
          this.setState({ EmailRepeat: false },()=>{
            document.getElementById("EmailRepeat").value = this.Customer.Email;
            this.setState({ EmailRepeat: $("#EmailRepeat").val() },()=>{this.checkEmail("Customer");});
          });

          document.getElementById("Phone").value = this.Customer.Phone;

          //AddressData
          document.getElementById("Zip").value = this.Customer.PostCode;
          document.getElementById("City").value = this.Customer.City;

          document.getElementById("Street").value = this.Customer.Street;

          document.getElementById("HouseNumber").value = this.Customer.HouseNumber;
          document.getElementById("HouseNumberAddition").value = this.Customer.HouseNumberAddition;

          document.getElementById("AddressAddition").value = this.Customer.Name3;

          //#endregion 
          
          //#region LegalGuardien
          //Daten gesetzlicher Vertreter
          let today = moment();
          let newDate = DateTimeHelper.StringToDate($("#DateOfBirth").val(),false,localStorage.getItem('vas_language'));
          let jahre = today.year() - newDate.year();
          if ((today.month() - newDate.month()) < 0){
              jahre--;
          } else {
              if ((today.month() - newDate.month()) === 0){
                  if ((today.date() - newDate.date()) < 0){
                      jahre--;
                  }
              }
          }
          if(jahre < 18){

            //PersonalData Legaluardian
            document.getElementById("Name1LegalGuardien").value = this.LegalGuardien.Name1;
            document.getElementById("Name2LegalGuardien").value = this.LegalGuardien.Name2;

            let cur = DateTimeHelper.StringToDate(this.LegalGuardien.DateOfBirth,true,localStorage.getItem('vas_language'));
            document.getElementById("DateOfBirthLegalGuardien").value = moment([cur.year(),cur.month(),cur.date()]).format("DD.MM.YYYY");
            
            let idx = 0;

            if(localStorage.getItem("Gender")!= ''){

              let selData = localStorage.getItem("Gender").split(',');
              for(let i = 0; i < selData.length; i++){
                if(selData[i] === this.LegalGuardien.Gender){
                  idx = i;
                }
              }
            }

            document.getElementById("GenderLegalGuardien").selectedIndex = idx+1;

            document.getElementById("EmailLegalGuardien").value = this.LegalGuardien.Email;
            this.refs.emailLegalGuardien.checkEmail('EmailLegalGuardien');
            this.setState({ EmailRepeatLegalGuardien: false },()=>{
              document.getElementById("EmailRepeatLegalGuardien").value = this.LegalGuardien.Email;
              this.setState({ EmailRepeatLegalGuardien: $("#EmailRepeatLegalGuardien").val() },()=>{this.checkEmail("LegalGuardien");});
            });

            document.getElementById("PhoneLegalGuardien").value = this.LegalGuardien.Phone == undefined ? "" : this.LegalGuardien.Phone;

            //AddressData LegalGuardian
            document.getElementById("ZipLegalGuardien").value = this.LegalGuardien.Zip == "" || this.LegalGuardien.Zip == undefined ? $("#ZipLegalGuardien").val() : this.LegalGuardien.Zip;
            document.getElementById("CityLegalGuardien").value = this.LegalGuardien.City == "" || this.LegalGuardien.City == undefined ? $("#CityLegalGuardien").val() : this.LegalGuardien.City;

            document.getElementById("StreetLegalGuardien").value = this.LegalGuardien.Street == "" || this.LegalGuardien.Street == undefined ? $("#StreetLegalGuardien").val() : this.LegalGuardien.Street;

            document.getElementById("HouseNumberLegalGuardien").value = this.LegalGuardien.HouseNumber == "" || this.LegalGuardien.HouseNumber == undefined ? $("#HouseNumberLegalGuardien").val() : this.LegalGuardien.HouseNumber;
            document.getElementById("HouseNumberAdditionLegalGuardien").value = this.LegalGuardien.HouseNumberAddition == "" || this.LegalGuardien.HouseNumberAddition == undefined ? $("#HouseNumberAdditionLegalGuardien").val() : this.LegalGuardien.HouseNumberAddition;

            document.getElementById("AddressAdditionLegalGuardien").value = this.LegalGuardien.Name3 == undefined ? "" : this.LegalGuardien.Name3;     
          }

          //#endregion
          
          //#region  Payment
          //PaymentData
          document.getElementById("accountOwnerName").value = this.AccountOwner.Name1 == undefined ? "" : this.AccountOwner.Name1;
          document.getElementById("accountOwnerFirstName").value = this.AccountOwner.Name2 == undefined ? "" : this.AccountOwner.Name2;

          if(document.getElementById("accountOwnerName").value.length > 0 && document.getElementById("accountOwnerFirstName").value.length > 0){
            let cur = DateTimeHelper.StringToDate(this.AccountOwner.DateOfBirth,true,localStorage.getItem('vas_language'));
            document.getElementById("DateOfBirthAccountOwner").value = moment([cur.year(),cur.month(),cur.date()]).format("DD.MM.YYYY");
          }else{

          }
          
          this.checkAccountOwner();

          document.getElementById("iban").value = this.Payment.Iban == undefined ? "" : this.Payment.Iban;
          if(document.getElementById("iban").value.length > 0){
            this.refs.iban.checkValue();
          }
          
          let valid = this.refs.iban.getValid();
          if (valid[0] === true){
            this.refs.bic.setState({ Value:valid[2],editable:false },()=>{
              this.checkBic();
            });
            
            this.setState({ PaymentDataValid:true });
          }else{
            this.refs.nameOfBank.setState({ Icon:'',Value:null,editable:true });
            this.refs.bic.setState({ Value:null,editable:true },()=>{
              this.checkBic();
            });

            this.setState({ PaymentDataValid:true });
          }
         

          document.getElementById("bic").value = this.Payment.Bic == undefined ? "" : this.Payment.Bic;
          this.refs.IconBic.setState({ Name:"Done",Color:"green" });
          document.getElementById("nameOfBank").value = this.Payment.BankName == undefined ? "" : this.Payment.BankName;
          

          if(this.AccountOwner.Name1 === this.Customer.Name1 
            && this.AccountOwner.Name2 === this.Customer.Name2 
            && DateTimeHelper.StringToDate(this.AccountOwner.DateOfBirth,true,localStorage.getItem('vas_language')).isSame(DateTimeHelper.StringToDate(this.Customer.DateOfBirth,true,localStorage.getItem('vas_language')),'day') )
            {

            }else{
              this.setState({CustomerEqualAccountOwner:false},()=>{
                let selData = this.refs.genderAccountOwner.state.Data;
                let idx = 0;

                if(selData != undefined){

                  for(let i = 0; i < selData.length; i++){
                    if(selData[i].Key === this.AccountOwner.Gender){
                      idx = i;
                    }
                  }
                }
                document.getElementById("GenderAccountOwner").selectedIndex = idx+1;
                document.getElementById("ZipAccountOwner").value = this.AccountOwner.PostCode == undefined ? "" : this.AccountOwner.PostCode;
                document.getElementById("CityAccountOwner").value = this.AccountOwner.City;

                document.getElementById("StreetAccountOwner").value = this.AccountOwner.Street;

                document.getElementById("HouseNumberAccountOwner").value = this.AccountOwner.HouseNumber;
                document.getElementById("HouseNumberAdditionAccountOwner").value = this.AccountOwner.HouseNumberAddition;

                document.getElementById("AddressAdditionAccountOwner").value = this.AccountOwner.Name3 == undefined ? "" : this.AccountOwner.Name3;
              });
              
            }
          //#endregion
        }
        localStorage.removeItem("ContractData");
      }
    }

    setEditable(){
      if(this.refs.email.getValid() === true && this.refs.email.getExist() === false){
        this.refs.emailRepeat.setState({ editable : true });
      }else{
        this.refs.emailRepeat.setState({ editable : false });
      }
    }
    //#endregion

    //#region check fields
    checkFields(){
      if(this.refs.HoneyPot.isFilled() === false){
        if (this.state.requiredFields && this.state.requiredSelectField && this.state.requiredCeckBox){
          
          let count = this.state.requiredFields.length + this.state.requiredSelectField.length + this.state.requiredCeckBox.length;
          let filled=0;

          let result = CheckFields.CheckTextFields(this.state.requiredFields);
          filled += result[0];
          let first = result[1];

          
          result = CheckFields.CheckSelectFields(this.state.requiredSelectField,first);
          filled += result[0];
          first = result[1];
          
          result = CheckFields.CheckCheckBox(this.state.requiredCeckBox,first);
          filled += result[0];
          first = result[1];
          
          if(this.state.CustomerOfAge === false){
            count += this.state.requiredFieldsLegalGuardien.length + this.state.requiredSelectFieldLegalGuardien.length;
            
            result = CheckFields.CheckTextFields(this.state.requiredFieldsLegalGuardien,first);
            filled += result[0];
            first = result[1];
            
            result = CheckFields.CheckSelectFields(this.state.requiredSelectFieldLegalGuardien,first);
            filled += result[0];
            first = result[1];
            
          }

          if(this.state.CustomerEqualAccountOwner === false){
            count += this.state.requiredFieldsAccountOwner.length + this.state.requiredSelectFieldsAccountOwner.length ;
            
            result = CheckFields.CheckTextFields(this.state.requiredFieldsAccountOwner,first);
            filled += result[0];
            first = result[1];

            result = CheckFields.CheckSelectFields(this.state.requiredSelectFieldsAccountOwner,first);
            filled += result[0];
            first = result[1];
          }
          
          if (filled < count){
              let docs=document.querySelectorAll('select,input');
              let docRefs = this.refs;
              CheckValues.checkAllFields(docs,docRefs,"");
              ReactDOM.render(<MessageBox
                Message={Vas.Resources.Labels["NotAllFields"]}
                Title={Vas.Resources.Titles["Note"]}
                Click={()=>{
                  this.jumpTofirst(first,first.Step); 
                }}
                />,document.getElementById('messageContainer'));
              return false;
          } else {
            
              if (this.state.allCertificates === true ){
                if(this.state.CustomerOfAge === true){
                  if(this.state.EmailRepeat === true){
                    return true;
                  }else{
                    this.jump(1);
                    let docs=document.querySelectorAll('select,input');
                    let docRefs = this.refs;
                    CheckValues.checkAllFields(docs,docRefs,"");
                    ReactDOM.render(<MessageBox
                      Message={Vas.Resources.Labels["NotAllFields"]}
                      Title={Vas.Resources.Titles["Note"]}
                      
                      />,document.getElementById('messageContainer'));
                    return false;
                  }
                }else{
                  if(document.getElementById("EmailLegalGuardien").value.length > 0){
                    if(this.state.EmailRepeatLegalGuardien === true){
                      return true;
                      }else{
                        this.jump(4);
                        let docs=document.querySelectorAll('select,input');
                        let docRefs = this.refs;
                        CheckValues.checkAllFields(docs,docRefs,"");
                        ReactDOM.render(<MessageBox
                          Message={Vas.Resources.Tooltips["Email"]}
                          Title={Vas.Resources.Titles["Note"]} />,document.getElementById('messageContainer'));
                        return false;
                      }
                  }else{
                    return true;
                  }
                }
              } else {
                
                this.jump(this.stepIdVerifications);
                  let docs=document.querySelectorAll('select,input');
                  let docRefs = this.refs;
                  CheckValues.checkAllFields(docs,docRefs,"");
                  ReactDOM.render(<MessageBox
                    Message={Vas.Resources.Labels["NotAllFields"]}
                    Title={Vas.Resources.Titles["Note"]} />,document.getElementById('messageContainer'));
                  return false;
              }
          }
        }
      }
    }

    jumpTofirst(first,id){
      stepperIconActiveId =Jump.jump(this.state.steps,id,null,stepperIconActiveId,first);
    }

    checkEmail(field) //Überprüft ob die wiederholte E-Mail-Adresse gleich der eingegebenen ist 
    {
      if(field === "Customer"){
        if($('#Email').val().length > 0 && $('#EmailRepeat').val().length > 0){
          if ($('#Email').val().toLowerCase() ===  $('#EmailRepeat').val().toLowerCase())
          {
            if(this.refs.email.getValid() === true && this.refs.email.getExist() === false){
              this.refs.IconMailRepeat.setState({ Name:"Done", Color:"green" });
              this.setState({ EmailRepeat: true });
            }
            else{
              this.refs.IconMailRepeat.setState({ Name:"Warning",Color:"red" });
              this.setState({ EmailRepeat: false });
              $('#EmailRepeat').val('');
              ReactDOM.render(<MessageBox
                AppURL={Vas.ApplicationUrl}
                Id={"MessageBox"}
                Title={Vas.Resources.Labels["Order"]}
                Message={Vas.Resources.Tooltips["Email"]}
                />
                , document.getElementById('messageContainer'));
              }
              
          }
          else
          {
            this.refs.IconMailRepeat.setState({ Name:"Warning",Color:"red" });
            this.setState({ EmailRepeat: false });
            $('#EmailRepeat').val('');
            ReactDOM.render(<MessageBox
              AppURL={Vas.ApplicationUrl}
              Id={"MessageBox"}
              Title={Vas.Resources.Labels["Order"]}
              Message={Vas.Resources.Labels["EmailRepeatNotValid"]}
              />
              , document.getElementById('messageContainer'));
          }
        }
        else{
          this.refs.IconMailRepeat.setState({ Name:"" });
          this.setState({ EmailRepeat: false });
        }
      }else if(field === "LegalGuardien"){
        if($('#EmailLegalGuardien').val().length > 0  && $('#EmailRepeatLegalGuardien').val().length > 0){
          if ($('#EmailLegalGuardien').val() ===  $('#EmailRepeatLegalGuardien').val())
          {
            
            if(this.refs.emailLegalGuardien.getValid() === true ){
                this.refs.IconMailRepeatLegalGuardien.setState({ Name:"Done", Color:"green" });
                this.setState({ EmailRepeatLegalGuardien: true });
            }else{
              this.refs.IconMailRepeatLegalGuardien.setState({ Name:"Warning",Color:"red" });
              this.setState({ EmailRepeatLegalGuardien: false });
              $('#EmailRepeatLegalGuardien').val('');
              ReactDOM.render(<MessageBox
                AppURL={Vas.ApplicationUrl}
                Id={"MessageBox"}
                Title={Vas.Resources.Labels["Order"]}
                Message={Vas.Resources.Tooltips["Email"]} />
                , document.getElementById('messageContainer'));
            }
              
          }
          else
          {
            this.refs.IconMailRepeatLegalGuardien.setState({ Name:"Warning",Color:"red" });
            this.setState({ EmailRepeatLegalGuardien: false });
            $('#EmailRepeatLegalGuardien').val('');
            ReactDOM.render(<MessageBox
              AppURL={Vas.ApplicationUrl}
              Id={"MessageBox"}
              Title={Vas.Resources.Labels["Order"]}
              Message={Vas.Resources.Labels["EmailRepeatNotValid"]} />
              , document.getElementById('messageContainer'));
          }
        }else{
          this.refs.IconMailRepeatLegalGuardien.setState({ Name:"",Color:"red" });
          this.setState({ EmailRepeatLegalGuardien: false });
        }
      }
      
    }

    checkIban() // Überprüft ob die eingegebene Iban valide ist
    {
      let me = this;
      this.refs.nameOfBank.setState({ Icon:"Loop" });

      let valid = this.refs.iban.getValid();
      if (valid[0] === true){
        if (valid[1]){
          me.refs.nameOfBank.setState({ Icon:'',Value:valid[1],editable:false });
          me.refs.bic.setState({ Value:valid[2],editable:false },()=>{
            this.checkBic();
          });
          
          this.Payment.Iban = $('#iban').val();
          this.Payment.BankName = valid[1];
          
          this.setState({ PaymentDataValid:true });
        } else {
          $("#nameOfBank").val('');
          $("#bic").val('');
          me.refs.nameOfBank.setState({ Icon:'',Value:null,editable:true });
          me.refs.bic.setState({ Value:null,editable:true },()=>{
            this.checkBic();
          });

          this.Payment.Iban = $('#iban').val();
          this.Payment.BankName = '';
          this.Payment.Bic = '';

          this.setState({ PaymentDataValid:true });
        }
      } else {
        $("#iban").val('');
        $("#nameOfBank").val('');
        $("#bic").val('');
        me.refs.nameOfBank.setState({ Icon:'',Value:null,editable:false });
        me.refs.bic.setState({ Value:null,editable:false },()=>{
          this.checkBic();
        });

        this.Payment.Iban = '';
        this.Payment.BankName = '';
        this.Payment.Bic = '';

        me.setState({ PaymentDataValid:false });
      }

      this.FontSizeClick();
    }

    checkBic(){
        let bic = $("#bic").val();
        if (bic.length === 11||bic.length === 8){
            this.refs.IconBic.setState({ Name:"Done",Color:"green" });
            this.Payment.Bic = $("#bic").val();
            
        } else {
            this.refs.IconBic.setState({ Name:"Warning",Color:"red" });
            $("#bic").val('');
        }
    }
    //#endregion

    Order()//Bestellen
    {
        let filled = this.checkFields();
        if (filled === true){
            $("#LoadingIconPopUp").removeClass().addClass('loaderSmall');
            this.refs.Order.setState({ usable:false });
            
            this.OrderModel.ContractIdToChange = null;

            let curContractStart = DateTimeHelper.StringToDate(this.tariff[1].ContractStart,true,localStorage.getItem('vas_language'));
            let curContractEnd = null;
            if (this.tariff[0].ContractEnd !== null){
                let cur = DateTimeHelper.StringToDate(this.tariff[0].ContractEnd,true,localStorage.getItem('vas_language'));
                curContractEnd =  moment([cur.year(),cur.month(),cur.date()]).format("YYYY-MM-DD T 00:00:00");
            }
            
            this.OrderModel.ContractStart = moment([curContractStart.year(),curContractStart.month(),curContractStart.date()]).format("YYYY-MM-DD T 00:00:00");
            this.OrderModel.ContractEnd = curContractEnd;
            this.OrderModel.CreateAccount = true;
            this.OrderModel.DeliveryToSchool = false;

            this.Customer.Street = this.Customer.Street == "" ? $("#Street").val() : this.Customer.Street;

            this.OrderModel.Customer = this.Customer;

            this.OrderModel.CustomerAccountOwner = null;

            this.AccountOwner.Street = this.AccountOwner.Street == ""? $("#StreetAccountOwner").val() : this.AccountOwner.Street;
            this.AccountOwner.Zip = this.AccountOwner.Zip == "" ? $("#ZipAccountOwner").val() : this.AccountOwner.Zip;
            this.LegalGuardien.Street = this.LegalGuardien.Street == ""? $("#StreetLegalGuardien").val() : this.LegalGuardien.Street;
            this.LegalGuardien.Zip = this.LegalGuardien.Zip == "" ? $("#ZipLegalGuardien").val() : this.LegalGuardien.Zip;

            if(this.state.CustomerEqualAccountOwner === false){
              this.OrderModel.CustomerAccountOwner = this.AccountOwner;

              //Hier bei der Reschnungsanschrift null übergeben
              //Wird hier nichts übergeben, wird eine leere Rechnungsanschrift im VAS angelegt
              this.OrderModel.CustomerBillAddress = null;
            } 
            else{
              //Hier bei der Reschnungsanschrift null übergeben
              //Wird hier nichts übergeben, wird eine leere Rechnungsanschrift im VAS angelegt
              this.OrderModel.CustomerBillAddress = null;
            }
            /*if(this.state.CustomerOfAge === false){
              this.OrderModel.CustomerLegalGuardian = this.LegalGuardien;
            }else{*/
              this.OrderModel.CustomerLegalGuardian = null;
            //}
            
            this.Payment.AccountOwner = this.AccountOwner.Name2 + " " + this.AccountOwner.Name1;
            this.Payment.PaymentMethodValue = 4;
            this.OrderModel.CustomerPaymentOption = this.Payment;

            this.OrderModel.SchoolId = null;

            this.OrderModel.SiblingChildren = [];
            
            this.OrderModel.TariffPointFrom = this.tariff[1];

            if(this.tariff[1].Version == ""){
              this.OrderModel.TariffPointFrom.Version = "0001-01-01 00:00:00";
            }

            if(this.tariff[1].TariffPointType == ""){
              this.OrderModel.TariffPointFrom.TariffPointType = "0";
            }

            this.OrderModel.TariffPointTo = this.tariff[2];

            if(this.tariff[2].Version == ""){
              this.OrderModel.TariffPointTo.Version = "0001-01-01 00:00:00";
            }

            if(this.tariff[2].TariffPointType == ""){
              this.OrderModel.TariffPointTo.TariffPointType = "0";
            }
            
            if(this.tariff[2].ContractStart == ""){
              this.OrderModel.TariffPointTo.ContractStart = "0001-01-01 00:00:00";
            }

            this.OrderModel.TariffProduct = this.tariff[0];

            localStorage.setItem('ContractOverviewCustomer',JSON.stringify(this.OrderModel.Customer));
            localStorage.setItem('ContractOverviewCustomerBirthdate', $("#DateOfBirth").val());
            localStorage.setItem('ContractOverviewCustomerPayment',JSON.stringify(this.OrderModel.CustomerPaymentOption));
            localStorage.setItem('ContractOverviewTariffPointFrom',JSON.stringify(this.OrderModel.TariffPointFrom));
            localStorage.setItem('ContractOverviewTariffPointTo',JSON.stringify(this.OrderModel.TariffPointTo));
            localStorage.setItem('ContractOverviewTariffProduct',JSON.stringify(this.OrderModel.TariffProduct));
            localStorage.setItem('ContractOverviewContractStart', DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(this.tariff[1].ContractStart,true,localStorage.getItem('vas_language'))));
            localStorage.setItem('ContractOverviewContractEnd', this.tariff[0].ContractEnd !== null ? DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(this.tariff[0].ContractEnd,true,localStorage.getItem('vas_language'))) : "");

            if(this.state.CustomerOfAge == false){
              localStorage.setItem('LegalGuardian',JSON.stringify(this.LegalGuardien));
              localStorage.setItem('LegalGuardianBirthDate', $("#DateOfBirthLegalGuardien").val());
            }

            if(this.state.CustomerEqualAccountOwner === false){
              localStorage.setItem('AccountOwner',JSON.stringify(this.AccountOwner));
              localStorage.setItem('AccountOwnerBirthDate', $("#DateOfBirthAccountOwner").val());
            }
            
            this.Request.setErrorHandler(()=>{
              ReactDOM.render(<MessageBox 
                AppURL={Vas.ApplicationUrl}  
                Title={Vas.Resources.Titles["Note"]} 
                Message={Vas.Resources.Labels["ActivateEmail"] +" " + Vas.Resources.Labels["ButDataError"]} 
                />,document.getElementById('messageContainer'));
            });

            let files = this.state.Files;
            let confirmationId = "";
            let dateFrom = "";
            let dateTo = "";
            let identificationNumber = "";
            let formData = files;

            if(this.state.ConfirmationsRequired === true){
                            
              localStorage.setItem("ExecutingForm", "OrderPopUp");

              for (let i = 0; i< files.length; i++){
                confirmationId += formData[i].confirmationId + ";";
                dateFrom += formData[i].datefrom + ";";
                dateTo += formData[i].dateto + ";";
                identificationNumber += formData[i].identificationNumber + ";";
              }

              this.OrderModel.Contracts("", confirmationId, dateFrom, dateTo, identificationNumber, formData);
            } else{
              this.OrderModel.Contracts();
            }
        }
    }
 
    //#region get Data
    getStreets(field)
    {
        let me = this;
        if( field === "Customer"){
          if (this.Customer.City.length > 0 && this.Customer.PostCode.length > 0){
            me.refs.street.setState({ Icon:"Loop" });
            me.StreetsModelCustomer.GetStreets(this.Customer.City,this.Customer.PostCode);
          }
        } else if( field === "LegalGuardien"){
          if (this.LegalGuardien.City.length > 0 && this.LegalGuardien.Zip.length > 0){
            me.refs.streetLegalGuardien.setState({ Icon:"Loop" });
            me.StreetsModelLegalGuardien.GetStreets(this.LegalGuardien.City, this.LegalGuardien.Zip);
          }
        }
        else if( field === "AccountOwner"){
          if (this.AccountOwner.City.length > 0 && this.AccountOwner.PostCode.length > 0){
            me.refs.streetAccountOwner.setState({ Icon:"Loop" });
            me.StreetsModelAccountOwner.GetStreets(this.AccountOwner.City, this.AccountOwner.PostCode);
          }
        }
    };

    getConfirmationFields(Data){//hole alle zum Kunden gehörenden Nachweise und prüfe, ob die benötigten bereits vorhanden sind
 
        if (!Data){
           Data = this.state.Confirmation; 
        }
        let existConfirm = [];
        existConfirm = this.state.existConfirm;
        if (Data){
            let count = Data.length;
            let filled = 0;

            Data.map(C =>{
              for (let i = 0; i< existConfirm.length; i++){
                  if (existConfirm[i] === C["Name"]){
                      filled++;
                  }
              }
            });
            if (filled === count){
                this.setState({ allCertificates: true,Confirmation:Data });
            } else {
                this.setState({ allCertificates: false,Confirmation:Data });
            }
        }
    }
    //#endregion

    //#region Confirmation
    
    setVerificationMonths(minValue,maxValue){
      let monthsArr = [Vas.Resources.Calendar["January"],Vas.Resources.Calendar["February"],Vas.Resources.Calendar["March"],Vas.Resources.Calendar["April"],
        Vas.Resources.Calendar["May"],Vas.Resources.Calendar["June"],Vas.Resources.Calendar["July"],Vas.Resources.Calendar["August"],
        Vas.Resources.Calendar["September"],Vas.Resources.Calendar["October"],Vas.Resources.Calendar["November"],Vas.Resources.Calendar["December"]];
      let months = [];
      if(document.getElementById('VerificationYear')){
        if(document.getElementById('VerificationYear').selectedIndex > 0){
          if(maxValue){
            let year = Number($("#VerificationYear").val());
            if(year === minValue.year()){
              let firstMonth = minValue.month();
              let count =monthsArr.length;
              if(year === maxValue.year()){
                count = maxValue.month()+1;
              }
              for(let i = firstMonth; i<count;i++){
                months.push({Display:monthsArr[i],Key:i});
              }
    
            }
            
            else if(year === maxValue.year()){
              let lastMonth = maxValue.month();
              for(let i = 0; i<=lastMonth;i++){
                months.push({Display:monthsArr[i],Key:i});
              }
            }
            
            else{
              for(let i = 0; i<monthsArr.length;i++){
                months.push({Display:monthsArr[i],Key:i});
              }
            }
          }else{
            let year = Number($("#VerificationYear").val());
            if(year === minValue.year()){
              let firstMonth = minValue.month();
              for(let i = firstMonth; i<monthsArr.length;i++){
                months.push({Display:monthsArr[i],Key:i});
              }
    
            }
            else{
              for(let i = 0; i<monthsArr.length;i++){
                months.push({Display:monthsArr[i],Key:i});
              }
            }
          }
          
        }else{
          for(let i = 0; i<monthsArr.length;i++){
            months.push({Display:monthsArr[i],Key:i});
          }
        }
      }else{
        for(let i = 0; i<monthsArr.length;i++){
          months.push({Display:monthsArr[i],Key:i});
        }
      }
      
      return months;
    }

    getUploadFileds(C){// lege Felder für das hochladen eines Nachweises 
  
        let from = <td></td>;
        let to =<td></td>;
        let id =<td></td>;
        let downloadDocumentButton = <div></div>;

        let btoUploadCertificate = true;

        $('#uploadFields').removeClass().addClass('uploadFieldsVisible');

        let minValue = DateTimeHelper.StringToDate(this.tariff[1].ContractStart,true,localStorage.getItem('vas_language'));

        if (C["DateFrom"] === true){
            from = (<td><DateField
              AppURL={Vas.ApplicationUrl}
              Language={localStorage.getItem("vas_language")}
              Width={220}
              Editable={true}
              IsRequired={true}
              Id={"CertificateStart"}
              Label={Vas.Resources.Labels["ValidFrom"]+ '*'}
              OnBlur={()=>{ this.setState({ CertificateStart: $("#CertificateStart").val() });}}
              MinValue={moment([minValue.year(),minValue.month(),minValue.date()])}
              FalseMinDateText={Vas.Resources.Labels["FalseDate"]}
              /></td>);
        }

        if (C["DateTo"] === true){
          if(C["MaxAge"] > 0){
            if(C["Name"].indexOf("Ermäßigung") > -1){

              /*to = (<td><DateField
                AppURL={Vas.ApplicationUrl}
                Language={localStorage.getItem("vas_language")}
                Width={220}
                Editable={true}
                IsRequired={true}
                Id={"CertificateEnd"}
                Label={Vas.Resources.Labels["ValidTo"]+ '*'}
                OnBlur={()=>{ 
                  let curDate = DateTimeHelper.StringToDate($("#CertificateEnd").val(),false,localStorage.getItem('vas_language'),false);
                  curDate.date(DateTimeHelper.GetLastDayOfMonth(curDate.month(),curDate.year()));
                  curDate = DateTimeHelper.FormatToShortDateString(curDate);
                  
                  this.setState({ CertificateEnd: curDate });}} 
                MinValue={moment([minValue.year(),minValue.month(),minValue.date()])}
                MaxValue={moment([minValue.year() + 1,minValue.month(),minValue.date()])}
                FalseMinDateText={Vas.Resources.Labels["FalseDate"]}
                ShowDay={false}
                /></td>);*/
              let countYears = 1 ;
              if(minValue.month() > 0){
                countYears = 2;
              }
              let maxValue = null;
              if(this.Customer.DateOfBirth.length > 0){
                
                let age = moment().diff(DateTimeHelper.StringToDate(this.Customer.DateOfBirth,true,localStorage.getItem("vas_language")),'years');
                let maxAge = C["MaxAge"];
                //countYears = maxAge >= age ? maxAge-age : 0;
                maxValue = DateTimeHelper.StringToDate(this.Customer.DateOfBirth,true,localStorage.getItem("vas_language")).add(maxAge,'years');
                if(maxValue.year() === minValue.year()){
                  countYears = 1;

                }else{
                  if(maxValue.isAfter(moment([minValue.year() + 1,minValue.month(),minValue.date()]))){
                    maxValue = moment([minValue.year() + 1,minValue.month()-1,minValue.date()]);
                   }
                }
                
              }else{
                maxValue = moment([minValue.year() + 1,minValue.month() -1,minValue.date()]);
              }
              
              let years= [];
              let startYear = minValue.year();
              for(let i = 0; i<countYears; i++){
                years.push({Display:startYear + i, Key: startYear + i});
              }
              to = (<td><table>
                <tbody>
                  <tr>
                    <td>
                      <div className={"ConfirmationLabel"}>{Vas.Resources.Labels["ValidTo"]}</div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <SelectField
                        Id={"VerificationYear"} 
                        AppURL={Vas.ApplicationUrl}
                        me={this}
                        IsRequired={true}
                        Label={Vas.Resources.Labels["Year"]+ "*"}
                        Data={ years }
                        OnChange={()=>{
                          this.setState({VerificationYear:$("#VerificationYear").val()},()=>{
                            if(document.getElementById('VerificationYear').selectedIndex > 0 && document.getElementById('VerificationMonth').selectedIndex > 0){
                              let curDate = moment([this.state.VerificationYear,this.state.VerificationMonth,1]);
                              curDate.date(DateTimeHelper.GetLastDayOfMonth(curDate.month(),curDate.year()));
                              curDate = DateTimeHelper.FormatToShortDateString(curDate);
                              
                              this.setState({ CertificateEnd: curDate });
                              this.UploadCertificateRef.current.setState({usable:true});
                            }
                          });
                          this.VerificationMonthRef.current.setState({Data:this.setVerificationMonths(minValue,maxValue)});
                        }}
                      />
                    </td>
                    <td>
                      <SelectField
                        Id={"VerificationMonth"} 
                        AppURL={Vas.ApplicationUrl}
                        me={this}
                        IsRequired={true}
                        Label={Vas.Resources.Labels["Month"]+ "*"}
                        ref={this.VerificationMonthRef}
                        Data = {this.setVerificationMonths(minValue)}
                        OnChange={()=>{
                          this.setState({VerificationMonth:$("#VerificationMonth").val()},()=>{
                            if(document.getElementById('VerificationYear').selectedIndex > 0 && document.getElementById('VerificationMonth').selectedIndex > 0){
                              let curDate = moment([this.state.VerificationYear,this.state.VerificationMonth,1]);
                              curDate.date(DateTimeHelper.GetLastDayOfMonth(curDate.month(),curDate.year()));
                              curDate = DateTimeHelper.FormatToShortDateString(curDate);
                              
                              this.setState({ CertificateEnd: curDate });
                              this.UploadCertificateRef.current.setState({usable:true});
                            }
                          });
                        }}
                      />
                    </td>
                  </tr>
                  
                </tbody>
              </table></td>);

            }else if(C["Name"] === "vsl. Ende der Ausbildung"){
              let countYears = 10 ;
              let maxValue = null;
              if(this.Customer.DateOfBirth.length > 0){
                let age = moment().diff(DateTimeHelper.StringToDate(this.Customer.DateOfBirth,true,localStorage.getItem("vas_language")),'years');
                let maxAge = C["MaxAge"];
                countYears = maxAge >= age ? maxAge-age : 0;
                maxValue = DateTimeHelper.StringToDate(this.Customer.DateOfBirth,true,localStorage.getItem("vas_language")).add(maxAge,'years');
              }
              
              
              let years= [];
              let startYear = minValue.year();
              for(let i = 0; i<countYears; i++){
                years.push({Display:startYear + i, Key: startYear + i});
              }
              to = (<td><table>
                <tbody>
                  <tr>
                    <td>
                      <div className={"ConfirmationLabel"}>{Vas.Resources.Labels["ValidTo"]}</div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <SelectField
                        Id={"VerificationYear"} 
                        AppURL={Vas.ApplicationUrl}
                        me={this}
                        IsRequired={true}
                        Label={Vas.Resources.Labels["Year"]+ "*"}
                        Data={ years }
                        OnChange={()=>{
                          this.setState({VerificationYear:$("#VerificationYear").val()},()=>{
                            if(document.getElementById('VerificationYear').selectedIndex > 0 && document.getElementById('VerificationMonth').selectedIndex > 0){
                              let curDate = moment([this.state.VerificationYear,this.state.VerificationMonth,1]);
                              curDate.date(DateTimeHelper.GetLastDayOfMonth(curDate.month(),curDate.year()));
                              curDate = DateTimeHelper.FormatToShortDateString(curDate);
                              
                              this.setState({ CertificateEnd: curDate });
                              this.UploadCertificateRef.current.setState({usable:true});
                            }
                          });
                          this.VerificationMonthRef.current.setState({Data:this.setVerificationMonths(minValue,maxValue)});
                        }}
                      />
                    </td>
                    <td>
                      <SelectField
                        Id={"VerificationMonth"} 
                        AppURL={Vas.ApplicationUrl}
                        me={this}
                        IsRequired={true}
                        Label={Vas.Resources.Labels["Month"]+ "*"}
                        ref={this.VerificationMonthRef}
                        Data = {this.setVerificationMonths(minValue)}
                        OnChange={()=>{
                          this.setState({VerificationMonth:$("#VerificationMonth").val()},()=>{
                            if(document.getElementById('VerificationYear').selectedIndex > 0 && document.getElementById('VerificationMonth').selectedIndex > 0){
                              let curDate = moment([this.state.VerificationYear,this.state.VerificationMonth,1]);
                              curDate.date(DateTimeHelper.GetLastDayOfMonth(curDate.month(),curDate.year()));
                              curDate = DateTimeHelper.FormatToShortDateString(curDate);
                              
                              this.setState({ CertificateEnd: curDate });
                              this.UploadCertificateRef.current.setState({usable:true});
                            }
                          });
                        }}
                      />
                    </td>
                  </tr>
                  
                </tbody>
              </table></td>);
            }
            else{
              let countYears = 10 ;
              let maxValue = null;
              if(this.Customer.DateOfBirth.length > 0){
                let age = moment().diff(DateTimeHelper.StringToDate(this.Customer.DateOfBirth,true,localStorage.getItem("vas_language")),'years');
                let maxAge = C["MaxAge"];
                countYears = maxAge >= age ? maxAge-age : 0;
                maxValue = DateTimeHelper.StringToDate(this.Customer.DateOfBirth,true,localStorage.getItem("vas_language")).add(maxAge,'years');
              }else{

              }
              to = (<td><DateField
                AppURL={Vas.ApplicationUrl}
                Language={localStorage.getItem("vas_language")}
                Width={220}
                Editable={true}
                IsRequired={true}
                Id={"CertificateEnd"}
                Label={Vas.Resources.Labels["ValidTo"]+ '*'}
                OnBlur={()=>{ this.setState({ CertificateEnd: $("#CertificateEnd").val() });}} 
                MinValue={moment([minValue.year(),minValue.month(),minValue.date()])}
                MaxValue={maxValue ? moment([maxValue.year(),maxValue.month(),maxValue.date()]).subtract(1,"day") : null}
                FalseMinDateText={Vas.Resources.Labels["FalseDate"]}
                /></td>);
            }
          }else{
            if(C["Name"].indexOf("Ermäßigung") > -1){
              to = (<td><DateField
                AppURL={Vas.ApplicationUrl}
                Language={localStorage.getItem("vas_language")}
                Width={220}
                Editable={true}
                IsRequired={true}
                Id={"CertificateEnd"}
                Label={Vas.Resources.Labels["ValidTo"]+ '*'}
                OnBlur={()=>{ 
                  let curDate = DateTimeHelper.StringToDate($("#CertificateEnd").val(),false,localStorage.getItem('vas_language'),false);
                  curDate.date(DateTimeHelper.GetLastDayOfMonth(curDate.month(),curDate.year()));
                  curDate = DateTimeHelper.FormatToShortDateString(curDate);
                  
                  this.setState({ CertificateEnd: curDate });}} 
                MinValue={moment([minValue.year(),minValue.month(),minValue.date()])}
                MaxValue={moment([minValue.year() + 1,minValue.month(),minValue.date()])}
                FalseMinDateText={Vas.Resources.Labels["FalseDate"]}
                ShowDay={false}
                /></td>);

            }
            else if(C["Name"] === "vsl. Ende der Ausbildung"){
              
              let years= [];
              let startYear = minValue.year();
              for(let i = 0; i<10; i++){
                years.push({Display:startYear + i, Key: startYear + i});
              }
              to = (<td><table>
                <tbody>
                  <tr>
                    <td>
                      <div className={"ConfirmationLabel"}>{Vas.Resources.Labels["ValidTo"]}</div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <SelectField
                        Id={"VerificationYear"} 
                        AppURL={Vas.ApplicationUrl}
                        me={this}
                        IsRequired={true}
                        Label={Vas.Resources.Labels["Year"]+ "*"}
                        Data={ years }
                        OnChange={()=>{
                          this.setState({VerificationYear:$("#VerificationYear").val()},()=>{
                            if(document.getElementById('VerificationYear').selectedIndex > 0 && document.getElementById('VerificationMonth').selectedIndex > 0){
                              let curDate = moment([this.state.VerificationYear,this.state.VerificationMonth,1]);
                              curDate.date(DateTimeHelper.GetLastDayOfMonth(curDate.month(),curDate.year()));
                              curDate = DateTimeHelper.FormatToShortDateString(curDate);
                              
                              this.setState({ CertificateEnd: curDate });
                              this.UploadCertificateRef.current.setState({usable:true});
                            }
                          });
                          this.VerificationMonthRef.current.setState({Data:this.setVerificationMonths(minValue)});
                        }}
                      />
                    </td>
                    <td>
                      <SelectField
                        Id={"VerificationMonth"} 
                        AppURL={Vas.ApplicationUrl}
                        me={this}
                        IsRequired={true}
                        Label={Vas.Resources.Labels["Month"]+ "*"}
                        ref={this.VerificationMonthRef}
                        Data = {this.setVerificationMonths(minValue)}
                        OnChange={()=>{
                          this.setState({VerificationMonth:$("#VerificationMonth").val()},()=>{
                            if(document.getElementById('VerificationYear').selectedIndex > 0 && document.getElementById('VerificationMonth').selectedIndex > 0){
                              let curDate = moment([this.state.VerificationYear,this.state.VerificationMonth,1]);
                              curDate.date(DateTimeHelper.GetLastDayOfMonth(curDate.month(),curDate.year()));
                              curDate = DateTimeHelper.FormatToShortDateString(curDate);
                              
                              this.setState({ CertificateEnd: curDate });
                              this.UploadCertificateRef.current.setState({usable:true});
                            }
                          });
                        }}
                      />
                    </td>
                  </tr>
                  
                </tbody>
              </table></td>);
            }
            else{
              to = (<td><DateField
                AppURL={Vas.ApplicationUrl}
                Language={localStorage.getItem("vas_language")}
                Width={220}
                Editable={true}
                IsRequired={true}
                Id={"CertificateEnd"}
                Label={Vas.Resources.Labels["ValidTo"]+ '*'}
                OnBlur={()=>{ this.setState({ CertificateEnd: $("#CertificateEnd").val() });}} 
                MinValue={moment([minValue.year(),minValue.month(),minValue.date()])}
                FalseMinDateText={Vas.Resources.Labels["FalseDate"]}
                /></td>);
            }
          }
        }

        if (C["IdentificationNumber"] === true){
            id = (<td colSpan={2}>
              <TextField
                AppURL={Vas.ApplicationUrl}
                Width={220}
                Id="IDField"
                Editable={true}
                IsRequired={true}
                Label={Vas.Resources.Labels["IdentificationNumber"]+ '*'}
                OnBlur={()=>{ this.setState({ IdentificationNumber: $("#IDField").val() });}} />
            </td>);
        }

        if(C["Name"].indexOf("Ermäßigung") > -1){
          downloadDocumentButton = (<div><ExtendedButton
              Id={"DownloadDocument"}
              Usable={true}
              Text={ Vas.Resources.Labels["ReductionDocumentDownload"] }
              Width={170}
              Float={"left"}
              OnClick={() => { window.open(Vas.ApplicationUrl+"/ErmäßigungABO.pdf") }} /></div>);
        }

        let FileText;

        let btoChooseIcon = <ExtendedButton 
        Id={"btoChoose"} 
        Usable={true} 
        Text={<Icon  
          Name={"Upload"} 
          Size={18} 
          Color={"black"} 
          PaddingLeft={'6px'} 
          PaddingTop={'0px'} 
          Tooltip={Vas.Resources.Tooltips["ChooseDocument"]}
          OnClick={()=>{$("#fileUpload").trigger('click');}} />} 
        Width={30} 
        Height={30} 
        Type={"Round"} />;

        if(Vas.isIE) {
          btoChooseIcon = <ExtendedButton 
            Id={"btoChoose"} 
            Usable={true} 
            Text={<Icon  
              Name={"Upload"} 
              Size={18} 
              Color={"black"} 
              PaddingLeft={'6px'} 
              PaddingTop={'0px'} 
              Tooltip={Vas.Resources.Tooltips["ChooseDocument"]} />} 
            Width={30} 
            Height={30} 
            Type={"Round"} />;
        }
      
        let btoChooseText = "";
        if(this.IconConfig.ShowIcons === false){
          btoChooseIcon="";
          btoChooseText = <ExtendedButton
            Id={"btoChoose"}
            Usable={true}
            Text={Vas.Resources.Labels["ChooseDocument"]}
            Width={150}
            OnClick={()=>{$("#fileUpload").trigger('click');}}/>;

          if(Vas.isIE) {
            btoChooseText = <ExtendedButton
              Id={"btoChoose"}
              Usable={true}
              Text={Vas.Resources.Labels["ChooseDocument"]}
              Width={150}/>;
          }
        }

        let hint = "";
        if(C["Description"].length > 0){
          hint = <div><b>{Vas.Resources.Titles["Note"]}: </b><i>{C["Description"]}</i></div>;
        }

        let classNameStandartControl = "standartInput";
        let additionTextField = <td></td>;
        let additionButton = <td></td>;

        if(this.UploadConfig.ShowStandardControl === false){
          classNameStandartControl = "inputfile";
          additionTextField = <td style={{ width:'170px' }}>
          <TextField
            ref={this.FileText }
            AppURL={Vas.ApplicationUrl}
            Width={170}
            Id="FileText"
            Value={this.state.fileName}
            Editable={false}
            Label={Vas.Resources.Labels["File"]+ '*'} />
        </td>;
          additionButton = <td colSpan={2}>
          <label htmlFor="fileUpload">
              {btoChooseText}
              
              </label>
          </td>;
        }

        ReactDOM.render(
          <table>
            <tbody>
              <tr>
                <td colSpan={2}>
                  <TextField
                    AppURL={Vas.ApplicationUrl}
                    Value={C["Name"]}
                    Width={220}
                    Id={"Text"}
                    Editable={false}
                    Label={Vas.Resources.Labels["CertificationType"]} />
                </td>
              </tr>
              <tr>
                <td colSpan={2}>
                  <div id={"certificationDescription"} style={{ margin: '10px' }}>{hint}</div>

                  { downloadDocumentButton }
                </td>
              </tr>
              <tr>
                <td>
                  <table>
                    <tbody>
                      <tr>
                        <td className={"btoTd"} style={{paddingTop:'25px'}}>
                          <input
                            id="fileUpload"
                            type="file"
                            name="files[]"
                            className={classNameStandartControl}
                            onChange={(event)=>{this.storeFile(event,C);}}
                            accept="image/bmp,image/png,image/jpeg,image/jpg, image/gif,application/pdf" />
                          <label htmlFor="fileUpload">{btoChooseIcon}</label>
                        </td>
                        {additionTextField}
                      </tr>
                      <tr>
                        {additionButton}
                        
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                {from}
                        
              </tr>
              <tr>
                {to}
              </tr>
              <tr>
                {id}
              </tr>
              <tr>
                <td colSpan={2}><br />
                  <div id={"validDocumentFormat"}>
                    {Vas.Resources.Labels["ValidDocumentFormat"]}
                    <br /><br />{Vas.Resources.Labels["ValidDocumentSize"]}
                  </div>
                </td>
              </tr>
              <tr>
                <td colSpan={2}>
                  <ExtendedButton
                    Id={"UploasdCertificateButton"}
                    Usable={btoUploadCertificate}
                    Text={Vas.Resources.Labels["UploadCertificate"]}
                    Float={"left"}
                    Width={170}
                    OnClick={()=>{this.uploadDocument(C);}}
                    ref={this.UploadCertificateRef}
                     />   
                </td>
              </tr> 
            </tbody>
          </table>
            , document.getElementById('uploadFields'));
            this.setState({ FileText:FileText });
    }

    storeFile(event,C){//Speichere Dokument in der Anwendung
        let type = event.target.files[0].type;
        if (((type.slice(0,5) === "image") || (type === "application/pdf")) && (event.target.files[0].size > 0) ){

          let maxFileSize = 10 * 1024 * 1000;

              if (event.target.files[0].size > maxFileSize){
                ReactDOM.render(<MessageBox 
                  AppURL={Vas.ApplicationUrl} 
                  Message={Vas.Resources.Labels["DocumentSizeInvalid"]} 
                  Title={Vas.Resources.Titles["Note"]} />
                    , document.getElementById('messageContainer'));

                    this.FileText.current.setState({ Value:'', TextTooltip : '' });
                    this.setState({ files:null, fileName:''});
              } else {

                let original = event.target.files[0].name;
                let name = event.target.files[0].name.split(".");

                if(name.length === 2){
                  let length = name[0].length;
                  let showName = name[0];
                  let showType = "." + name[1];
                  if(length > 20){
                  showName = name[0].substr(0,19) + "...";
                  }
                  original = showName + showType;
                }
                
                if(this.UploadConfig.ShowStandardControl === false){
                  if (this.FileText.current){
                      this.FileText.current.setState({ Value:original, TextTooltip : event.target.files[0].name });
                  }
                }
                  this.setState({ files:event.target.files, fileName:event.target.files[0].name },()=>{
                      this.getUploadFileds(C);
                  });
              } 
        }else{
          if(event.target.files[0].size === 0){
            ReactDOM.render(<MessageBox 
              AppURL={Vas.ApplicationUrl} 
              Message={Vas.Resources.Labels["FileNoContent"]} 
              Title={Vas.Resources.Titles["Note"]} />
                , document.getElementById('messageContainer'));
          }
        }
    }

    uploadDocument(field){//lade Nachweis in die Datenbank hoch

        let start = DateTimeHelper.StringToDate(this.tariff[1].ContractStart,true,localStorage.getItem('vas_language'));
        $("#LoadingIconPopUp").removeClass().addClass('loaderSmall');
        

        let ok = false;
        let falseDate = false;
        
        let data = {
          file : null,
          confirmationId : '',
          datefrom : null,
          dateto : null,
          identificationNumber : null
        };

        if (this.state.files){
            for (var i = 0; i < this.state.files.length; i++) {
                data.file = this.state.files[i];

                ok = true;
            }
        }

        data.confirmationId = field.Ident;

        if (ok === true){
            if (field.DateFrom === true){
                if (this.state.CertificateStart){
                    let certStart = DateTimeHelper.StringToDate(this.state.CertificateStart,false,localStorage.getItem('vas_language'));

                    if (certStart.isSameOrBefore(start, 'day') === true){
                        data.datefrom = moment([certStart.year(),certStart.month(),certStart.date()]).format("YYYY-MM-DD T 00:00:00");

                        ok = true; 
                    } else {
                        ok = false;
                        falseDate = true;
                    }
                } else {
                    ok = false;
                }
            } else {
                //formData.append("datefrom", null);
            }
        }
        
        if (ok === true){

            if(field.Name == "Ermäßigung ab 16" && field.DateTo === false){

              let contractStart = DateTimeHelper.StringToDate(this.tariff[1].ContractStart,true,localStorage.getItem('vas_language'));

              data.dateto = moment([contractStart.year() + 1,contractStart.month(),contractStart.date()]).format("YYYY-MM-DD T 00:00:00");

              ok = true;
            } else if (field.DateTo === true){
                if (this.state.CertificateEnd){
                   
                    let certEnd =DateTimeHelper.StringToDate(this.state.CertificateEnd,false,localStorage.getItem('vas_language'));

                    if (certEnd.isSameOrAfter(start,'day') === true){
                        data.dateto = moment([certEnd.year(),certEnd.month(),certEnd.date()]).format("YYYY-MM-DD T 00:00:00");

                        ok = true;
                    } else {
                        ok = false;
                        falseDate = true;
                    }
                } else {
                    ok = false;
                }
            } else {
                //formData.append("dateto", null);
            }
        }
        
        if (ok === true){
            if (field.IdentificationNumber === true){
                if (this.state.IdentificationNumber){
                    data.identificationNumber = this.state.IdentificationNumber;

                    ok = true;
                } else {
                    ok = false;
                }
            } else {
                //formData.append("identificationNumber", null);
            }
        }
           
        if (ok === true){
            
            let curr = [];
            curr = this.state.Files;
            curr.push(data);

            let exist = [];
            exist = this.state.existConfirm;
            exist.push(field.Name);

            this.setState({ existConfirm:exist,Files:curr });
            this.setState({ CertificationType:null,CertificateStart:null,CertificateEnd:null,IdentificationNumber:null,requiredFieldsCertificate:null, files:null, fileName:'' });
            $('#uploadFields').removeClass().addClass('uploadFields');
            ReactDOM.unmountComponentAtNode(document.getElementById('uploadFields'));
            $("#LoadingIconPopUp").removeClass().addClass('hide');
            this.getConfirmationFields();
        } else {
            $("#LoadingIconPopUp").removeClass().addClass('hide');
            if (falseDate === true){
                ReactDOM.render(<MessageBox
                  AppURL={Vas.ApplicationUrl}
                  Title={Vas.Resources.Titles["Note"]}
                  Message={Vas.Resources.Labels["FalseDate"]} />, document.getElementById('messageContainer'));
            } else {
                ReactDOM.render(<MessageBox
                  AppURL={Vas.ApplicationUrl}
                  Title={Vas.Resources.Titles["Note"]}
                  Message={Vas.Resources.Labels["NotAllFields"]} />, document.getElementById('messageContainer'));
            }
        }
    }
    //#endregion

    //#region Stepper
    setStepVerifications(){
      let Data ='';
      if (!this.state.RequiredConfirmations){
        Data = this.state.Confirmation; 
      }else{
        Data =this.state.RequiredConfirmations;
      }
      let existConfirm = [];
      existConfirm = this.state.existConfirm;

      
      if(Data){

        let perso;
        let bank;
        let restData = [];

        Data.forEach(function(value){
          if(value.Name == "Personalausweis"){
            perso = value;
          }
          else if(value.Name == "Bankverbindungsnachweis"){
            bank = value;
          } else{
            restData.push(value);
          }
        });

        //Data leeren
        Data = [];

        //Perso und Bankverbindung in Data schreiben, wenn vorhanden
        if(perso != undefined){
          Data.push(perso);
        }

        if(bank != undefined){
          Data.push(bank);
        }

        //restlichen Nachweise in Data schreiben
        restData.forEach(function(value){
          Data.push(value);
        });

        let j = 0;

        return (
          <table style={{ width: '375px'}}>
            <tbody>
            <tr>
              <td colSpan='2'>
                <br /><div className={"ConfirmationLabel"}>{Vas.Resources.Labels["RequiredField"]}</div><br />
              </td>
              <td></td>
            </tr>
              <tr>
                <td id={"confirmationFields"}>
                <table>
                  <tbody>
                    {
                          Data.map(C =>{

                              j++;

                              let exist = false;
                              for (let i = 0; i< existConfirm.length; i++){
                                  if (existConfirm[i] === C["Name"]){
                                      exist = true;
                                  }
                              }
                              
                              if (exist === true){
                                  return (
                                    <tr key={C["Name"]}>
                                      <td>
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td style={{ width:'200px' }}>
                                                <div className={"ConfirmationLabel"}>{C["Name"]}</div>
                                              </td>
                                              <td>
                                                <Icon
                                                  Name={"Done"}
                                                  Size={24}
                                                  Color={"green"}
                                                  Align={"left"}
                                                  Tooltip={Vas.Resources.Tooltips["StillUploaded"]} />
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  );
                              } else {
                                let notUploaded = <Icon
                                  Name={"Warning"}
                                  Size={24}
                                  Color={"red"}
                                  Align={"left"}
                                  OnClick={()=>{this.getUploadFileds(C);}}
                                  Tooltip={Vas.Resources.Tooltips["NotUploaded"]} />;
                                if(this.IconConfig.ShowIcons === false){
                                      notUploaded = <ExtendedButton
                                      Id={"btoChoose_" + j}
                                      Usable={true}
                                      Text={Vas.Resources.Labels["UploadDocument"]}
                                      Width={150}
                                      OnClick={()=>{this.getUploadFileds(C); this.LogoClick(); this.FontSizeClick(); }}
                                  />;
                                }
                                  return (
                                    <tr key={C["Name"]}>
                                      <td>
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td style={{ width:'200px' }}>
                                                <div className={"ConfirmationLabel"}>{C["Name"]}</div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                
                                                {notUploaded}
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  );
                              }
                          }) 
                          }
                  </tbody>
                </table>
                </td>
              </tr>
              <tr>
                <td
                  className={"uploadFields"}
                  id={"uploadFields"} >
                </td>
              </tr>
            </tbody>
          </table>
        );
      } else {
        return( <table></table>);
      }     
      
    }

    setStepLegalGuardianPersonal(){

      let currentDate = new Date();

      let maxBirthDate = new Date();
      if(this.tariff){
        if(this.tariff[0].RequiredAge !== null){
          let requiredAge = this.tariff[0].RequiredAge;

          maxBirthDate = new Date(currentDate.getFullYear() - requiredAge, currentDate.getMonth(), currentDate.getDate() );
        }
      }
      

      return (
        <table style={{ width: '505px'}}>
                  <tbody>
                  <tr>
                    <td colSpan='2'>
                      <br /><div className={"ConfirmationLabel"}>{Vas.Resources.Labels["RequiredField"]}</div><br />
                    </td>
                    <td></td>
                  </tr>
                    <tr>
                      <td colSpan='2'>                         
                        <div className={"LeftContainer"}>
                          <TextField
                          AppURL={Vas.ApplicationUrl}
                          me={this}
                          Modus={"Name"}
                          ref={"nameLegalGuardien"}
                          IsRequired={true}
                          Editable={true}
                          Id={"Name1LegalGuardien"}
                          Label={Vas.Resources.Labels["Name"] + "*"}
                          OnChange={()=>{ this.LegalGuardien.Name1= $("#Name1LegalGuardien").val() ; }}
                          Tooltip={Vas.Resources.Tooltips["Name"]} /></div>
                        <div className={"RightContainer"}>
                          <TextField
                          AppURL={Vas.ApplicationUrl}
                          me={this}
                          Modus={"Name"}
                          ref={"firstNameLegalGuardien"}
                          IsRequired={true}
                          Editable={true}
                          Id={"Name2LegalGuardien"}
                          Label={Vas.Resources.Labels["FirstName"]+ "*"}
                          OnChange={()=>{ this.LegalGuardien.Name2 = $("#Name2LegalGuardien").val() ; }}
                          Tooltip={Vas.Resources.Tooltips["Firstname"]} /></div>
                      </td> 
                    </tr>
                    <tr>
                      <td colSpan='2'>
                        <div className={"LeftContainer"}>
                          <DateField
                          AppURL={Vas.ApplicationUrl}
                          Language={localStorage.getItem("vas_language")}
                          me={this}
                          Editable={true}
                          ref={"dateOfBirthLegalGuardien"}
                          MaxValue={moment(maxBirthDate)}
                          IsRequired={true}
                          Id={"DateOfBirthLegalGuardien"}
                          Tooltip={Vas.Resources.Tooltips["DateOfBirth"]}
                          Label={Vas.Resources.Labels["DateOfBirth"]+ "*"}
                          OnBlur={()=>{ 
                            let cur = DateTimeHelper.StringToDate($("#DateOfBirthLegalGuardien").val(),false,localStorage.getItem('vas_language'));
                            this.LegalGuardien.DateOfBirth = moment([cur.year(),cur.month(),cur.date()]).format("YYYY-MM-DDT00:00:00");
                          }}
                          FalseMaxDateText={Vas.Resources.Labels["NoFutureDateOfBirth"]} /></div>
                        <div className={"RightContainer"}>
                          <SelectField
                          Width={170}
                          AppURL={Vas.ApplicationUrl}
                          me={this}
                          ref={"genderLegalGuardien"}
                          IsRequired={true}
                          Id={"GenderLegalGuardien"}
                          //Float={'left'}
                          Label={Vas.Resources.Labels["Gender"]+ "*"}
                          Data={ this.state.GenderValues }
                          OnChange={()=>{ this.LegalGuardien.Gender = $("#GenderLegalGuardien").val();}}
                          Tooltip={Vas.Resources.Tooltips["Gender"]} /></div>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <EmailField
                        AppURL={Vas.ApplicationUrl}
                        me={this}
                        Id={"EmailLegalGuardien"}
                        ref={"emailLegalGuardien"}
                        Editable={true}
                        IsRequired={false}
                        Tooltip={Vas.Resources.Tooltips["Email"]} 
                        Label={Vas.Resources.Labels["Email"]}
                        //OnChange={()=>{this.setState({ Email: $("#Email").val() }); }}
                        ApiUrl={Vas.ApiUrl}
                        ApiKey={Vas.ApiKey}
                        Token={localStorage.getItem["vas_token"]}
                        AnonymousToken={localStorage.getItem["anonymous_token"]}
                        OnBlur={()=>{
                          this.LegalGuardien.Email = $("#EmailLegalGuardien").val();
                          this.setState({ EmailRepeatLegalGuardien: false },()=>{
                            document.getElementById('EmailRepeatLegalGuardien').value = '';
                            this.refs.IconMailRepeatLegalGuardien.setState({ Name:"",Color:"red" });
                        }); }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <table>
                          <tbody>
                            <tr>
                              <td>
                                <div id={"mailRepeat"}>
                                <TextField
                                  AppURL={Vas.ApplicationUrl}
                                  me={this}
                                  ref={"emailRepeatLegalGuardien"}
                                  Editable={true}
                                  IsRequired={false}
                                  Id={"EmailRepeatLegalGuardien"}
                                  Label={Vas.Resources.Labels["EmailRepeat"]}
                                  //OnBlur={()=>{ this.checkEmail();}}
                                  //OnChange={()=>{ this.setState({ EmailRepeat: $("#EmailRepeat").val() }); }} 
                                  OnBlur={()=>{ this.setState({ EmailRepeatLegalGuardien: $("#EmailRepeatLegalGuardien").val() },()=>{this.checkEmail("LegalGuardien");}); }}
                                  Tooltip={Vas.Resources.Tooltips["EmailRepeat"]}
                                  />
                                  </div>
                              </td>
                              <td>
                                <Icon
                                  Id={"iconMailRepeatLegalGuardien"}
                                  ref={"IconMailRepeatLegalGuardien"}
                                  Name={""}
                                  Size={24}
                                  Color={"red"}
                                  Align={"left"} />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td><TextField
                        Modus={"TelNumber"}
                        AppURL={Vas.ApplicationUrl}
                        me={this}
                        Editable={true}
                        ref={"phoneLegalGuardien"}
                        Id={"PhoneLegalGuardien"}
                        Label={Vas.Resources.Labels["Phone"]}
                        OnChange={()=>{ this.LegalGuardien.Phone = $("#PhoneLegalGuardien").val() ; }} 
                        Tooltip={Vas.Resources.Tooltips["Phone"]}
                        /></td>
                    </tr>
                  </tbody>
                </table>
       );
    }

    setStepLegalGuardianAdress(){
      return (
        <table style={{ width: '505px'}}>
                  <tbody>
                  <tr>
                    <td colSpan='2'>
                      <br /><div className={"ConfirmationLabel"}>{Vas.Resources.Labels["RequiredField"]}</div><br />
                    </td>
                    <td></td>
                  </tr>
                    <tr>
                      <td colSpan='2'>
                        <div className={"LeftContainer"}>
                          <TextField
                          Modus={"Number"}
                          AppURL={Vas.ApplicationUrl}
                          me={this}
                          ref={"zipLegalGuardien"}
                          Id={"ZipLegalGuardien"}
                          IsRequired={true}
                          Editable={true}
                          Label={Vas.Resources.Labels["Zip"]+ "*"}
                          OnBlur={()=>{ 

                            if ($("#ZipLegalGuardien").val().length === 5){
                              this.LegalGuardien.Zip = $("#ZipLegalGuardien").val();
                            } else {
                              $("#ZipLegalGuardien").val('');
                              ReactDOM.render(<MessageBox 
                                Message={Vas.Resources.Labels["PLZNote"]} 
                                Title={Vas.Resources.Titles["Note"]}
                                Field={"ZipLegalGuardien"} />
                                  ,document.getElementById('messageContainer'));
                            }
                          }}
                          Tooltip={Vas.Resources.Tooltips["Zip"]} />
                        </div>
                        <div className={"RightContainer"}>
                            <TextField
                            AppURL={Vas.ApplicationUrl}
                            me={this}
                            ref={"cityLegalGuardien"}
                            Id={"CityLegalGuardien"}
                            IsRequired={true}
                            Editable={true}
                            Label={Vas.Resources.Labels["Place"]+ "*"}
                            OnChange={()=>{ this.LegalGuardien.City = $("#CityLegalGuardien").val() ; }}
                            OnBlur={()=>{this.getStreets("LegalGuardien");}}
                            Tooltip={Vas.Resources.Tooltips["Place"]} />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={2}><AutocompleteField
                        AppURL={Vas.ApplicationUrl}
                        TitleMessageFalseStreet={Vas.Resources.Labels["Error"]}
                        MessageFalseStreet={Vas.Resources.Labels["FalseStreet"]}
                        me={this}
                        Width={346}
                        Modus={"Street"}
                        IsRequired={true}
                        ref={"streetLegalGuardien"}
                        Id={"StreetLegalGuardien"}
                        Float={'left'}
                        editable={true}
                        Label={Vas.Resources.Labels["Street"]+ "*"}
                        Data={this.state.streets}
                        OnBlur={()=>{ this.LegalGuardien.Street = $("#StreetLegalGuardien").val();}}
                        Tooltip={Vas.Resources.Tooltips["Street"]}
                        TimeOutTime={Vas.TimeOutTime} /></td>
                    </tr>
                    <tr>
                      <td colSpan='2'>
                        <div className={"LeftContainer"}>
                          <TextField
                          Modus={"Number"}
                          AppURL={Vas.ApplicationUrl}
                          me={this}
                          Editable={true}
                          ref={"houseNumberLegalGuardien"}
                          IsRequired={true}
                          Id={"HouseNumberLegalGuardien"}
                          Label={Vas.Resources.Labels["HouseNumber"]+ "*"}
                          OnChange={()=>{
                            this.LegalGuardien.HouseNumber = $("#HouseNumberLegalGuardien").val(); 
                          }}
                          Tooltip={Vas.Resources.Tooltips["Housenumber"]}
                          /></div>
                        <div className={"RightContainer"}>
                          <TextField
                          AppURL={Vas.ApplicationUrl}
                          me={this}
                          Editable={true}
                          ref={"houseNumberAdditionLegalGuardien"}
                          Id={"HouseNumberAdditionLegalGuardien"}
                          Label={Vas.Resources.Labels["HouseNumberAddition"]}
                          OnChange={()=>{ this.LegalGuardien.HouseNumberAddition = $("#HouseNumberAdditionLegalGuardien").val(); }}
                          Tooltip={Vas.Resources.Tooltips["HouseNumberAddition"]}
                          /></div>
                        </td>
                    </tr>
                    <tr>
                      <td colSpan={2}><TextField
                        AppURL={Vas.ApplicationUrl}
                        me={this}
                        Editable={true}
                        Width={346}
                        ref={"adressAdditionLegalGuardien"}
                        Id={"AddressAdditionLegalGuardien"}
                        Label={Vas.Resources.Labels["AdditionAdress"]}
                        OnChange={()=>{ this.LegalGuardien.Name3 = $("#AddressAdditionLegalGuardien").val() ; }}
                        Tooltip={Vas.Resources.Tooltips["AddressAddition"]} /></td>
                    </tr>
                  </tbody>
                </table>
      );
    }

    setStepDataProtection(){
      /*let contractEnd = this.tariff[0].ContractEnd;
        let picker = '';
        if (contractEnd !== null){
            picker = (<TextField
              AppURL={Vas.ApplicationUrl}
              Width={170}
              Editable={false}
              ref={"contractEnd"}
              Id={"ContractEnd"}
              Label={Vas.Resources.Labels["ContractEnd"]}
              Value={DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(contractEnd,true,localStorage.getItem('vas_language')))} />);
        } else {
            picker = (<TextField
              AppURL={Vas.ApplicationUrl}
              Width={170}
              Editable={false}
              ref={"contractEnd"}
              Id={"ContractEnd"}
              Label={Vas.Resources.Labels["ContractEnd"]}
              Value={Vas.Resources.Labels["Unlimited"]} />);
        }*/
        return (
          <table>
                    <tbody>
                    <tr>
                      <td colSpan='2'>
                        <br /><div className={"ConfirmationLabel"}>{Vas.Resources.Labels["RequiredField"]}</div><br />
                      </td>
                      <td></td>
                    </tr>
                      {/*<tr>
                        <td><div className={"ConfirmationLabel"}>{Vas.Resources.Labels["NoteContractEnd"]}</div></td>
                      </tr>
                      <tr>
                        <td>{picker}</td>
                      </tr>*/}
                      <tr >
                        <td colSpan={2}><div className={"ConfirmationLabel"}><label htmlFor="cbox" ><a
                          href={Vas.ApplicationUrl+"/20_10_16_Hinweise_zur_Datenverarbeitung_und_zum_Datenschutz.pdf"}
                          target="_blank"
                    rel="noopener noreferrer" >{Vas.Resources.Labels["PrivacyPolicy"]}</a> </label></div><br /></td>
                      </tr>    
                      <tr >
                        <td colSpan={2}><div className={"ConfirmationLabel"}><label htmlFor="cbox" ><a
                          href={this.ConfigDataProtection.LinkTarifBestimmungen}
                          target="_blank"
                          rel="noopener noreferrer" >{Vas.Resources.Labels["TariffPolicy"]}</a> </label></div><br /></td>
                      </tr>
                      <tr >
                        <td>
                          <table>
                            <tbody>
                              <tr>
                                <td
                                  colSpan={2}
                                  valign="top" ><Checkbox
                                    ref={"AcceptPrivacyTariffTerms"}
                                    Id={"checkboxAcceptPrivacyTariffTerms"}
                                    onClick={()=>{this.setState({ AcceptPrivacyTariffTerms:$("#acceptPrivacyTariffTerms").val() });}} /></td>
                                <td><div className={"ConfirmationLabel"}>{Vas.Resources.Labels["AcceptPrivacyTariffTerms"]}*</div></td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
        );
    }

    setStepPayment(){

      let address = <tr></tr>;
      if(this.state.CustomerEqualAccountOwner === false){
        address = <tr>
          <td>
            <table>
              <tbody>
                <tr>
                  <td colSpan={2}>
                    <div className={"LeftContainer"}>
                        <SelectField
                          Width={170}
                          AppURL={Vas.ApplicationUrl}
                          me={this}
                          ref={"genderAccountOwner"}
                          IsRequired={true}
                          Id={"GenderAccountOwner"}
                          //Float={'left'}
                          Label={Vas.Resources.Labels["Gender"]+ "*"}
                          Data={ this.state.GenderValues }
                          OnChange={()=>{ this.AccountOwner.Gender = $("#GenderAccountOwner").val();}}
                          Tooltip={Vas.Resources.Tooltips["Gender"]} />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colSpan='2'>
                    <div className={"LeftContainer"}>
                      <TextField
                      Modus={"Number"}
                      AppURL={Vas.ApplicationUrl}
                      me={this}
                      ref={"zipAccountOwner"}
                      Id={"ZipAccountOwner"}
                      IsRequired={true}
                      Editable={true}
                      Label={Vas.Resources.Labels["Zip"]+ "*"}
                      OnBlur={()=>{ 

                        if ($("#ZipAccountOwner").val().length === 5){
                          this.AccountOwner.PostCode = $("#ZipAccountOwner").val(); 
                        } else {
                          $("#ZipAccountOwner").val('');
                          ReactDOM.render(<MessageBox 
                            Message={Vas.Resources.Labels["PLZNote"]} 
                            Title={Vas.Resources.Titles["Note"]}
                            Field={"ZipAccountOwner"} />
                              ,document.getElementById('messageContainer'));
                        }
                      }}
                      Tooltip={Vas.Resources.Tooltips["Zip"]}
                      />
                    </div>
                    <div className={"RightContainerAccountOwner"} >
                        <TextField
                        AppURL={Vas.ApplicationUrl}
                        me={this}
                        ref={"cityAccountOwner"}
                        Id={"CityAccountOwner"}
                        IsRequired={true}
                        Editable={true}
                        Label={Vas.Resources.Labels["Place"]+ "*"}
                        OnChange={()=>{ this.AccountOwner.City = $("#CityAccountOwner").val() ; }}
                        OnBlur={()=>{this.getStreets("AccountOwner");}}
                        Tooltip={Vas.Resources.Tooltips["Place"]} />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colSpan={2}><AutocompleteField
                    AppURL={Vas.ApplicationUrl}
                    TitleMessageFalseStreet={Vas.Resources.Labels["Error"]}
                    MessageFalseStreet={Vas.Resources.Labels["FalseStreet"]}
                    me={this}
                    Width={346}
                    Modus={"Street"}
                    IsRequired={true}
                    ref={"streetAccountOwner"}
                    Id={"StreetAccountOwner"}
                    Float={'left'}
                    editable={true}
                    Label={Vas.Resources.Labels["Street"]+ "*"}
                    Data={this.state.streets}
                    OnBlur={()=>{ this.AccountOwner.Street = $("#StreetAccountOwner").val();}}
                    Tooltip={Vas.Resources.Tooltips["Street"]}
                    TimeOutTime={Vas.TimeOutTime} /></td>
                </tr>
                <tr>
                  <td colSpan='2'>
                    <div className={"LeftContainer"}>
                      <TextField
                      Modus={"Number"}
                      AppURL={Vas.ApplicationUrl}
                      me={this}
                      Editable={true}
                      ref={"houseNumberAccountOwner"}
                      IsRequired={true}
                      Id={"HouseNumberAccountOwner"}
                      Label={Vas.Resources.Labels["HouseNumber"]+ "*"}
                      OnChange={()=>{
                        this.AccountOwner.HouseNumber = $("#HouseNumberAccountOwner").val(); 
                      }}
                      Tooltip={Vas.Resources.Tooltips["Housenumber"]} /></div>
                    <div className={"RightContainerAccountOwner"} >
                      <TextField
                      AppURL={Vas.ApplicationUrl}
                      me={this}
                      Editable={true}
                      ref={"houseNumberAdditionAccountOwner"}
                      Id={"HouseNumberAdditionAccountOwner"}
                      Label={Vas.Resources.Labels["HouseNumberAddition"]}
                      OnChange={()=>{ this.AccountOwner.HouseNumberAddition = $("#HouseNumberAdditionAccountOwner").val(); }} 
                      Tooltip={Vas.Resources.Tooltips["HouseNumberAddition"]}
                      /></div>
                    </td>
                </tr>
                <tr>
            <td colSpan={2}><TextField
              AppURL={Vas.ApplicationUrl}
              me={this}
              Editable={true}
              Width={346}
              ref={"adressAdditionAccountOwner"}
              Id={"AddressAdditionAccountOwner"}
              Label={Vas.Resources.Labels["AdditionAdress"]}
              OnChange={()=>{ this.AccountOwner.Name3 = $("#AddressAdditionAccountOwner").val() ; }}
              Tooltip={Vas.Resources.Tooltips["AddressAddition"]} /></td>
          </tr>
              </tbody>
            </table>
          </td>
        </tr>

        this.FontSizeClick();
      }
      return(
        <table style={{ width: '505px'}}>
                    <tbody>
                    <tr>
                      <td colSpan='2'>
                        <br /><div className={"ConfirmationLabel"}>{Vas.Resources.Labels["RequiredField"]}</div><br />
                      </td>
                      <td></td>
                    </tr>
                      <tr>
                        <td colSpan={2}><b><div className={"ConfirmationLabel"}>{Vas.Resources.Titles["Note"]}:</div></b> <div className={"ConfirmationLabel"}>{Vas.Resources.Labels["NotePayment"]}</div></td>
                      </tr>
                      <tr>
                        <td colSpan='2'>
                          <div className={"LeftContainer"}><TextField
                            AppURL={Vas.ApplicationUrl}
                            me={this}
                            ref={"accountOwnerName"}
                            Id="accountOwnerName"
                            Editable={true}
                            IsRequired={true}
                            Label={Vas.Resources.Labels["DepositorName"]}
                            OnChange={()=>{ this.AccountOwner.Name1 = $("#accountOwnerName").val(); this.checkAccountOwner(); }}
                            Tooltip={Vas.Resources.Tooltips["Name"]}
                            /></div>
                          <div className={"RightContainer"}><TextField
                            AppURL={Vas.ApplicationUrl}
                            me={this}
                            ref={"accountOwnerFirstName"}
                            Id="accountOwnerFirstName"
                            Editable={true}
                            IsRequired={true}
                            Label={Vas.Resources.Labels["DepositorFirstname"]}
                            OnChange={()=>{ this.AccountOwner.Name2 = $("#accountOwnerFirstName").val() ; this.checkAccountOwner();}}
                            Tooltip={Vas.Resources.Tooltips["Firstname"]}
                            /></div>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan='2'>
                          <div >
                            <DateField
                              AppURL={Vas.ApplicationUrl}
                              Language={localStorage.getItem("vas_language")}
                              me={this}
                              Editable={true}
                              ref={"dateOfBirthAccountOwner"}
                              MaxValue={moment()}
                              IsRequired={true}
                              Id={"DateOfBirthAccountOwner"}
                              Tooltip={Vas.Resources.Tooltips["DateOfBirth"]}
                              Label={Vas.Resources.Labels["DateOfBirth"]}
                              OnBlur={()=>{ 
                                let cur = DateTimeHelper.StringToDate($("#DateOfBirthAccountOwner").val(),false,localStorage.getItem('vas_language'));
                                this.AccountOwner.DateOfBirth = moment([cur.year(),cur.month(),cur.date()]).format("YYYY-MM-DDT00:00:00");
                                this.checkAccountOwner();
                              }}
                              FalseMaxDateText={Vas.Resources.Labels["NoFutureDateOfBirth"]} />
                          </div>
                        </td>
                      </tr>
                      {address}
                      <tr>
                        <td colSpan={2}>
                          <IbanField
                          AppURL={Vas.ApplicationUrl}
                          ApiUrl={Vas.ApiUrl}
                          ApiKey={Vas.ApiKey}
                          Token={localStorage.getItem["vas_token"]}
                          AnonymousToken={localStorage.getItem["anonymous_token"]}
                          me={this}
                          ref={"iban"}
                          Id="iban"
                          Editable={true}
                          IsRequired={true}
                          Label={Vas.Resources.Labels["Iban"]}
                          OnBlur={()=>{this.checkIban();}} /></td><td></td>
                      </tr>
                      <tr>
                        <td colSpan={2}><TextField
                          AppURL={Vas.ApplicationUrl}
                          me={this}
                          ref={"bic"}
                          Id="bic"
                          Editable={false}
                          IsRequired={true}
                          Label={Vas.Resources.Labels["Bic"]}
                          OnBlur={()=>{this.checkBic();}}
                          Tooltip={Vas.Resources.Tooltips["BicLength"]} /><Icon
                            ref={"IconBic"}
                            Name={"Warning"}
                            Size={24}
                            Color={"red"}
                            Align={"left"} /></td>
                      </tr>
                      <tr>
                        <td colSpan={2}><TextField
                          AppURL={Vas.ApplicationUrl}
                          me={this}
                          ref={"nameOfBank"}
                          Id="nameOfBank"
                          Editable={false}
                          Label={Vas.Resources.Labels["NameOfBank"]}
                          OnBlur={()=>{ this.Payment.BankName = $("#nameOfBank").val();}} /></td>
                      </tr>
                      <tr>
                        <td colSpan={2} >
                          <table>
                            <tbody>
                              <tr>
                                <td>
                                  <Checkbox
                                    ref={"AcceptPaymentTerms"}
                                    Id={"checkboxAcceptPaymentTerms"}
                                    onClick={()=>{this.setState({ AcceptPaymentTerms:$("#checkboxAcceptPaymentTerms").val() });}} />
                                </td>
                                <td>
                                  {/*<div className={"ConfirmationLabel"}>{Vas.Resources.Labels["PaymentText"]}*</div>*/}
                                  <div id="confirmationLabelSepa" className={"ConfirmationLabel"}>{Vas.Resources.Labels["SEPA"]}*
                                    {/*<label htmlFor="cbox" ><a
                                  href={Vas.ApplicationUrl+"/ErteilungSEPA.pdf"}
                                  target="_blank"
                            rel="noopener noreferrer" >{Vas.Resources.Labels["SEPA"]}*</a> </label>*/}
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td colSpan={2}>
                                  <ExtendedButton
                                    Id={"PaymentTerms"}
                                    Usable={true}
                                    Text={ Vas.Resources.Labels["ViewHere"] }
                                    Width={170}
                                    Float={"left"}
                                    OnClick={() => { window.open(Vas.ApplicationUrl+"/ErteilungSEPA.pdf") }} />
                                </td>
                              </tr>
                          </tbody>
                        </table>
                        </td>
                      </tr>
                  </tbody>
                  </table>
      );
    }

    setStepOrder(){
      return(
        <table style={{ width:"500px" }}>
                    <tbody>
                      <tr>
                        <td>
                          <b id={"MarketingComplienceId"}>{Vas.Resources.Labels["MarketingComplience"]} </b>
                        </td>
                      </tr>
                      <tr> 
                        <td>
                          <Checkbox 
                            ref={"MarketingMail"} 
                            Id={"ceckboxMarketingMail"} 
                            onClick={()=>{this.Customer.MarketingEmail = document.getElementById("ceckboxMarketingMail").checked;}} 
                            IsRequired={true} />
                          <label htmlFor="cbox">{Vas.Resources.Labels["MarketingComplienceMail"]} 
                          </label>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <Checkbox 
                            ref={"MarketingPhone"} 
                            Id={"ceckboxMarketingPhone"} 
                            onClick={()=>{
                              this.Customer.MarketingPhone = document.getElementById("ceckboxMarketingPhone").checked;
                              this.setMarketingPhone(document.getElementById("ceckboxMarketingPhone").checked);
                            }} 
                            IsRequired={true} />
                          <label htmlFor="cbox">{Vas.Resources.Labels["MarketingCompliencePhone"]} 
                          </label>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <Checkbox 
                            ref={"MarketingPost"} 
                            Id={"ceckboxMarketingPost"} 
                            onClick={()=>{this.Customer.MarketingPost = document.getElementById("ceckboxMarketingPost").checked;}} 
                            IsRequired={true} />
                          <label htmlFor="cbox">{Vas.Resources.Labels["MarketingCompliencePost"]} 
                          </label>
                        </td>
                      </tr>
                      
                      
                    </tbody>
                  </table>
      );
    }

    setStepOverview(){

      let legalGuardianPersonalData = '';
      let legalGuardianAdressData = '';

      let accountOwnerAdressData = '';

      if(this.state.CustomerOfAge == false){
          legalGuardianPersonalData = (<table id={"PersonalDataLegalGuardian"}>
            <tbody>
                  <tr>
                    <td colSpan={5}>
                        <br/>
                        <br/>
                        <div id={ "PersonalDataLegalGuardianHeadline" } style={{ width: '360px'}}>
                          <b>{ Vas.Resources.Labels["PersonalData"] + " " + Vas.Resources.Labels["LegalGuardien"] }</b>
                        </div>
                        <br/>
                        <br/>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div id={"PersonalDataLegalGuardian_LeftContainer"}>
                        <div id={"PersonalDataLegalGuardian_NameHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Name"]}:</b></div>
                    
                        <div id={"PersonalDataLegalGuardian_Name1"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                      </div>  
                    
                      <div id={"PersonalDataLegalGuardian_Empty"}></div>
                    
                      <div id={"PersonalDataLegalGuardian_RightContainer"}>                    
                        <div id={"PersonalDataLegalGuardian_FirstNameHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["FirstName"]}:</b></div>
                    
                        <div id={"PersonalDataLegalGuardian_Name2"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                      </div>  
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div id={"PersonalDataLegalGuardian_LeftContainer"}>
                        <div id={"PersonalDataLegalGuardian_DateOfBirthHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["DateOfBirth"]}:</b></div>
                    
                        <div id={"PersonalDataLegalGuardian_DateOfBirth"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                      </div>
                    
                      <div id={"PersonalDataLegalGuardian_Empty"}></div>

                      <div id={"PersonalDataLegalGuardian_RightContainer"}>
                        <div id={"PersonalDataLegalGuardian_GenderHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Gender"]}:</b></div>
                    
                        <div id={"PersonalDataLegalGuardian_Gender"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                      </div>  
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div id={"PersonalDataLegalGuardian_LeftContainer"}>
                        <div id={"PersonalDataLegalGuardian_EmailHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Email"]}:</b></div>
                    
                        <div id={"PersonalDataLegalGuardian_Email"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                      </div>  
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div id={"PersonalDataLegalGuardian_LeftContainer"}>
                        <div id={"PersonalDataLegalGuardian_PhoneHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Phone"]}:</b></div>

                        <div id={"PersonalDataLegalGuardian_Phone"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                      </div>  
                    </td>
                  </tr>
                  <tr>
                    <td className={"ButtonBack_Cell"} colspan={5}>
                    <ExtendedButton
                      Id={"PersonalDataLegalGuardian_ButtonBack"}
                      Usable={true}
                      Text={ Vas.Resources.Labels["ChangePersonalDataLegalGuardian"] }
                      Width={430}
                      Float={"left"}
                      OnClick={() => { this.jump((4), 0); }} />
                    </td>
                  </tr>
            </tbody>
          </table>);

          legalGuardianAdressData = (<table id={"AddressDataLegalGuardian"}>
            <tbody>
                <tr>
                  <td colSpan={5}>
                      <br/>
                      <br/>
                      <div id={"AddressDataLegalGuardianHeadline"} style={{ width: '430px'}}>
                        <b>{ Vas.Resources.Labels["Addressdata"] + " " + Vas.Resources.Labels["LegalGuardien"] }</b>
                      </div>
                      <br/>
                      <br/>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div id={"AddressDataLegalGuardian_LeftContainer"}>
                      <div id={"AddressDataLegalGuardian_ZipHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Zip"]}:</b></div>
                  
                      <div id={"AddressDataLegalGuardian_Zip"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                    </div>

                    <div id={"AddressDataLegalGuardian_Empty"}></div>

                    <div id={"AddressDataLegalGuardian_RightContainer"}>
                      <div id={"AddressDataLegalGuardian_PlaceHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Place"]}:</b></div>
                  
                      <div id={"AddressDataLegalGuardian_Place"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                    </div>  
                  </td>
                </tr>
                <tr>
                  <td>
                    <div id={"AddressDataLegalGuardian_LeftContainer"}>
                      <div id={"AddressDataLegalGuardian_StreetHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Street"]}:</b></div>
                  
                      <div id={"AddressDataLegalGuardian_Street"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                    </div>  
                  </td>
                </tr>
                <tr>
                  <td>
                    <div id={"AddressDataLegalGuardian_LeftContainer"}>
                      <div id={"AddressDataLegalGuardian_HouseNumberHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["HouseNumber"]}:</b></div>
                  
                      <div id={"AddressDataLegalGuardian_HouseNumber"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                    </div>
                    
                    <div id={"AddressDataLegalGuardian_Empty"}></div>
                    
                    <div id={"AddressDataLegalGuardian_RightContainer"}>
                      <div id={"AddressDataLegalGuardian_HouseNumberAdditionHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["HouseNumberAddition"]}:</b></div>
                    
                      <div id={"AddressDataLegalGuardian_HouseNumberAddition"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                    </div>  
                  </td>
                </tr>
                <tr>
                  <td>
                    <div id={"AddressDataLegalGuardian_LeftContainer"}>
                      <div id={"AddressDataLegalGuardian_AddressAdditionHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '157px', float: 'left' }}><b>{Vas.Resources.Labels["AddressAddition"]}:</b></div>
                  
                      <div id={"AddressDataLegalGuardian_AddressAddition"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                    </div>  
                  </td>
                </tr>
                <tr>
                    <td className={"ButtonBack_Cell"} colspan={5}>
                    <ExtendedButton
                      Id={"AddressDataLegalGuardian_ButtonBack"}
                      Usable={true}
                      Text={ Vas.Resources.Labels["ChangeAddressDataLegalGuardian"] }
                      Width={420}
                      Float={"left"}
                      OnClick={() => { this.jump((5), 0); }} />
                    </td>
                  </tr>
            </tbody>
          </table>);
          
      }

      if(this.state.CustomerEqualAccountOwner === false){
        accountOwnerAdressData = (<table id={"AddressDataAccountOwner"}>
            <tbody>
                <tr>
                  <td colSpan={5}>
                      <br/>
                      <br/>
                      <div id={"AddressDataAccountOwnerHeadline"} style={{ width: '430px'}}>
                        <b>{ Vas.Resources.Labels["Addressdata"] + " " + Vas.Resources.Labels["AccountOwner"] }</b>
                      </div>
                      <br/>
                      <br/>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div id={"AddressDataAccountOwner_LeftContainer"}>
                      <div id={"AddressDataAccountOwner_GenderHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Gender"]}:</b></div>
                      
                      <div id={"AddressDataAccountOwner_Gender"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div id={"AddressDataAccountOwner_LeftContainer"}>
                      <div id={"AddressDataAccountOwner_ZipHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Zip"]}:</b></div>
                  
                      <div id={"AddressDataAccountOwner_Zip"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                    </div>

                    <div id={"AddressDataAccountOwner_Empty"}></div>

                    <div id={"AddressDataAccountOwner_RightContainer"}>
                      <div id={"AddressDataAccountOwner_PlaceHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Place"]}:</b></div>
                  
                      <div id={"AddressDataAccountOwner_Place"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                    </div>  
                  </td>
                </tr>
                <tr>
                  <td>
                    <div id={"AddressDataAccountOwner_LeftContainer"}>
                      <div id={"AddressDataAccountOwner_StreetHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Street"]}:</b></div>
                  
                      <div id={"AddressDataAccountOwner_Street"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                    </div>  
                  </td>
                </tr>
                <tr>
                  <td>
                    <div id={"AddressDataAccountOwner_LeftContainer"}>
                      <div id={"AddressDataAccountOwner_HouseNumberHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["HouseNumber"]}:</b></div>
                  
                      <div id={"AddressDataAccountOwner_HouseNumber"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                    </div>

                    <div id={"AddressDataAccountOwner_Empty"}></div>

                    <div id={"AddressDataAccountOwner_RightContainer"}>
                      <div id={"AddressDataAccountOwner_HouseNumberAdditionHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["HouseNumberAddition"]}:</b></div>
                  
                      <div id={"AddressDataAccountOwner_HouseNumberAddition"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                    </div>  
                  </td>
                </tr>
                <tr>
                  <td>
                    <div id={"AddressDataAccountOwner_LeftContainer"}>
                      <div id={"AddressDataAccountOwner_AddressAdditionHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["AddressAddition"]}:</b></div>

                      <div id={"AddressDataAccountOwner_AddressAddition"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                    </div>  
                  </td>
                </tr>
                <tr>
                    <td className={"ButtonBack_Cell"} colspan={5}>
                    <ExtendedButton
                      Id={"AddressDataAccountOwner_ButtonBack"}
                      Usable={true}
                      Text={ Vas.Resources.Labels["ChangeAddressDataAccountOwner"] }
                      Width={420}
                      Float={"left"}
                      OnClick={() => { this.jump((3), 0); }} />
                    </td>
                  </tr>
            </tbody>
          </table>);
      }
      return(
        <table style={{ width: '825px'}}>
          <tbody>
            
            <table id={"ContractData"}>
              <tbody>
                <tr>
                  <td colSpan={5}>
                      <br/>
                      <br/>
                      <div id={"ContractDataHeadline"} style={{ width: '360px'}}>
                        <b>{ Vas.Resources.Labels["ContractData"] }</b>
                      </div>
                      <br/>
                      <br/>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div id={"ContractData_LeftContainer"}>
                      <div id={"ContractData_TicketNameHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["ProductSelection"]}:</b></div>

                      <div id={"ContractData_TicketName"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                    </div>

                    <div id={"ContractData_Empty"}></div>

                    <div id={"ContractData_RightContainer"}>
                      <div id={"ContractData_ContractStartHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["ContractStart"]}:</b></div>

                      <div id={"ContractData_ContractStart"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div id={"ContractData_LeftContainer"}>
                      <div id={"ContractData_DescriptionLongFromHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["From"]}:</b></div>

                      <div id={"ContractData_DescriptionLongFrom"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div id={"ContractData_LeftContainer"}>
                      <div id={"ContractData_DescriptionLongToHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["To"]}:</b></div>

                      <div id={"ContractData_DescriptionLongTo"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div id={"ContractData_LeftContainer"}>
                      <div id={"ContractData_TzViaLabel"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Via"]}:</b></div>
                  
                      <div id={"ContractData_TzViaText"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                    </div>  
                  </td>
                </tr>
                <tr>
                  <td>
                    <div id={"ContractData_LeftContainer"}>
                      <div id={"ContractData_PriceHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["ProductPrice"]}:</b></div>
                  
                      <div id={"ContractData_Price"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div id={"ContractData_LeftContainer"}>
                      <div id={"ContractData_PriceLevelHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["PriceLevel"]}:</b></div>
                  
                      <div id={"ContractData_PriceLevel"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div id={"ContractData_LeftContainer"}>
                      <div id={"ContractData_ContractEndHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["ContractEnd"]}:</b></div>
                  
                      <div id={"ContractData_ContractEnd"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                    </div>  
                  </td>
                </tr>
                <tr>
                  <td className={"ButtonBack_Cell"} colSpan={5}>
                    <ExtendedButton
                      Id={"ContractData_ButtonBack"}
                      Usable={true}
                      Text={ Vas.Resources.Labels["ChangeContractData"] }
                      Width={180}
                      Float={"left"}
                      OnClick={()=>{ 
                        localStorage.setItem("ContractData",JSON.stringify([this.Customer,this.LegalGuardien,this.AccountOwner,this.Payment]));
                        Vas.GetView("Tariffing",{ BackButton: 'Back' },false);
                        
                      }} />
                  </td>
                </tr>
              </tbody>
            </table>

            <table id={"PersonalData"}>
              <tbody>
                  <tr>
                    <td colSpan={5}>
                        <br/>
                        <br/>
                        <div id={"PersonalDataHeadline"} style={{ width: '400px'}}>
                          <b>{ Vas.Resources.Labels["PersonalData"] + " " + Vas.Resources.Labels["TicketCustomer"] }</b>
                        </div>
                        <br/>
                        <br/>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div id={"PersonalData_LeftContainer"}>
                        <div id={"PersonalData_NameHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Name"]}:</b></div>

                        <div id={"PersonalData_Name1"} style={{ fontSize:'14px', textAlign: 'left', float: 'left' }}></div>
                      </div>

                      <div id={"PersonalData_Empty"}></div>
                    
                      <div id={"PersonalData_RightContainer"}>
                        <div id={"PersonalData_FirstNameHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["FirstName"]}:</b></div>

                        <div id={"PersonalData_Name2"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div id={"PersonalData_LeftContainer"}>
                        <div id={"PersonalData_DateOfBirthHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["DateOfBirth"]}:</b></div>

                        <div id={"PersonalData_DateOfBirth"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                      </div>
                    
                      <div id={"PersonalData_Empty"}></div>

                      <div id={"PersonalData_RightContainer"}>

                        <div id={"PersonalData_GenderHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Gender"]}:</b></div>
                    
                        <div id={"PersonalData_Gender"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                      </div>  
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div id={"PersonalData_LeftContainer"}>
                        <div id={"PersonalData_EmailHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Email"]}:</b></div>
                    
                        <div id={"PersonalData_Email"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                      </div>  
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div id={"PersonalData_LeftContainer"}>
                        <div id={"PersonalData_PhoneHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Phone"]}:</b></div>
                    
                        <div id={"PersonalData_Phone"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className={"ButtonBack_Cell"} colspan={5}>
                      <ExtendedButton
                        Id={"PersonalData_ButtonBack"}
                        Usable={true}
                        Text={ Vas.Resources.Labels["ChangePersonalData"] }
                        Width={400}
                        Float={"left"}
                        OnClick={() => { this.jump((1), 0); }} />
                    </td>
                  </tr>
              </tbody>
            </table>

            <table id={"AddressData"}>
              <tbody>
                <tr>
                  <td colSpan={5}>
                      <br/>
                      <br/>
                      <div id={"AddressDataHeadline"} style={{ width: '360px'}}>
                        <b>{ Vas.Resources.Labels["Addressdata"] + " " + Vas.Resources.Labels["TicketCustomer"] }</b>
                      </div>
                      <br/>
                      <br/>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div id={"AddressData_LeftContainer"}>
                      <div id={"AddressData_ZipHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Zip"]}:</b></div>
                  
                      <div id={"AddressData_Zip"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                    </div>
                  
                    <div id={"AddressData_Empty"}></div>

                    <div id={"AddressData_RightContainer"}>

                      <div id={"AddressData_PlaceHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Place"]}:</b></div>
                  
                      <div id={"AddressData_Place"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                    </div>  
                  </td>
                </tr>
                <tr>
                  <td>
                    <div id={"AddressData_LeftContainer"}>
                      <div id={"AddressData_StreetHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Street"]}:</b></div>
                  
                      <div id={"AddressData_Street"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                    </div>  
                  </td>
                </tr>
                <tr>
                  <td>
                    <div id={"AddressData_LeftContainer"}>
                      <div id={"AddressData_HouseNumberHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["HouseNumber"]}:</b></div>

                      <div id={"AddressData_HouseNumber"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                    </div>
                  
                    <div id={"AddressData_Empty"}></div>
                  
                    <div id={"AddressData_RightContainer"}>
                      <div id={"AddressData_HouseNumberAdditionHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["HouseNumberAddition"]}:</b></div>
                  
                      <div id={"AddressData_HouseNumberAddition"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                    </div>  
                  </td>
                </tr>
                <tr>
                  <td>
                    <div id={"AddressData_LeftContainer"}>
                      <div id={"AddressData_AddressAdditionHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["AddressAddition"]}:</b></div>
                  
                      <div id={"AddressData_AddressAddition"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                    </div>  
                  </td>
                </tr>
                <tr>
                    <td className={"ButtonBack_Cell"} colspan={5}>
                      <ExtendedButton
                        Id={"AddressData_ButtonBack"}
                        Usable={true}
                        Text={ Vas.Resources.Labels["ChangeAddressData"] }
                        Width={400}
                        Float={"left"}
                        OnClick={() => { this.jump((2), 0); }} />
                    </td>
                  </tr>
              </tbody>
            </table>

            <table id={"PaymentData"}>
              <tbody>
                <tr>
                  <td colSpan={5}>
                      <br/>
                      <br/>
                      <div id={"PaymentDataHeadline"} style={{ width: '360px'}}>
                        <b>{ Vas.Resources.Labels["MethodOfPaymentCustomer"] }</b>
                      </div>
                      <br/>
                      <br/>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div id={"PaymentData_LeftContainer"}>
                      <div id={"PaymentData_DepositorNameHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["DepositorName"]}:</b></div>
                    
                      <div id={"PaymentData_DepositorName"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                    </div>  
                  
                    <div id={"PaymentData_Empty"}></div>
                  
                    <div id={"PaymentData_RightContainer"}>                   
                      <div id={"PaymentData_DepositorFirstnameHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["DepositorFirstname"]}:</b></div>
                    
                      <div id={"PaymentData_DepositorFirstname"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div id={"PaymentData_LeftContainer"}>
                      <div id={"PaymentData_IbanHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Iban"]}:</b></div>
                  
                      <div id={"PaymentData_Iban"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div id={"PaymentData_LeftContainer"}>
                      <div id={"PaymentData_BicHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Bic"]}:</b></div>
                  
                      <div id={"PaymentData_Bic"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                    </div>  
                  </td>
                </tr>
                <tr>
                  <td>
                    <div id={"PaymentData_LeftContainer"}>
                      <div id={"PaymentData_NameOfBankHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["NameOfBank"]}:</b></div>
                  
                      <div id={"PaymentData_NameOfBank"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}></div>
                    </div>  
                  </td>
                </tr>
                <tr>
                <td className={"ButtonBack_Cell"} colspan={5}>
                  <ExtendedButton
                    Id={"PaymentData_ButtonBack"}
                    Usable={true}
                    Text={ Vas.Resources.Labels["ChangePaymentData"] }
                    Width={180}
                    Float={"left"}
                    OnClick={() => { this.jump((3), 0); }} />
                </td>
              </tr>
              </tbody>
          </table>

            {accountOwnerAdressData}

            { legalGuardianPersonalData }

            { legalGuardianAdressData }

          </tbody>
        </table>
      );
    }


    setStepsDataProtectionPaymentOrder(id){
      let data = this.setStepDataProtection();
      let dataProtection = '';
      let i = 0;
      if(this.ConfigDataProtection.Order === true){
        dataProtection = this.buildStepperTable(id,Vas.Resources.Labels["PrivacyTariffTerms"],data,true,true,false);
        stepIdDataProtection = id;
        i++;
      }else{
        dataProtection = this.buildStepperTableNotVisible("DataProtection",Vas.Resources.Labels["PrivacyTariffTerms"],data);
      }
      
      //let pay = this.setStepPayment();
      //let payment = this.buildStepperTable(id+1,Vas.Resources.Labels["MethodOfPaymentCustomer"],pay,true,true,false);
      //stepIdPayment = id + 1;

      let order = this.setStepOrder();
      let orderstep = this.buildStepperTable(id+i,Vas.Resources.Labels["MarketingCaptcha"],order,true,true,false);
      stepIdCaptcha = id + i;
      i++;

      stepIdOverview = id + i;

      let overView = this.setStepOverview();
      let overViewStep = this.buildStepperTable(stepIdOverview,Vas.Resources.Labels["ConfirmOrder"],overView,false,true,true);

      return(
        <div>
          {dataProtection}
          {/*{payment}*/}
          {orderstep}
          {overViewStep}
        </div>
      );
    }

    setStepCustomerPersonal(){

      return(
        <table style={{ width: '505px'}}>
          <tbody>
          <tr>
            <td colSpan='2'>
              <br /><div className={"ConfirmationLabel"}>{Vas.Resources.Labels["RequiredField"]}</div><br />
            </td>
            <td></td>
          </tr>
          <tr>
            <td><HoneyPot
                    ref={"HoneyPot"}
                  /></td>
          </tr>
            <tr>
              <td colSpan='2'>                          
                <div className={"LeftContainer"}>
                  <TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  Modus={"Name"}
                  ref={"name"}
                  IsRequired={true}
                  Editable={true}
                  Id={"Name1"}
                  Label={Vas.Resources.Labels["Name"]}
                  OnChange={()=>{ this.Customer.Name1 = $("#Name1").val() ; }}
                  Tooltip={Vas.Resources.Tooltips["Name"]} /></div>
                <div className={"RightContainer"}>
                  <TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  Modus={"Name"}
                  ref={"firstName"}
                  IsRequired={true}
                  Editable={true}
                  Id={"Name2"}
                  Label={Vas.Resources.Labels["FirstName"]}
                  OnChange={()=>{ this.Customer.Name2 =  $("#Name2").val() ; }}
                  Tooltip={Vas.Resources.Tooltips["Firstname"]} /></div>
              </td>
            </tr>
            <tr>
              <td colSpan='2'>
                <div className={"LeftContainer"}>
                  <DateField
                  AppURL={Vas.ApplicationUrl}
                  Language={localStorage.getItem("vas_language")}
                  me={this}
                  Editable={true}
                  ref={"dateOfBirth"}
                  IsRequired={true}
                  Id={"DateOfBirth"}
                  Tooltip={Vas.Resources.Tooltips["DateOfBirth"]}
                  Label={Vas.Resources.Labels["DateOfBirth"]}
                  OnBlur={()=>{ 
                    let cur = DateTimeHelper.StringToDate($("#DateOfBirth").val(),false,localStorage.getItem('vas_language'));
                    this.Customer.DateOfBirth = moment([cur.year(),cur.month(),cur.date()]).format("YYYY-MM-DDT00:00:00");
                    this.checkOfAge($("#DateOfBirth").val());
                    if(document.getElementById('uploadFields')){
                      ReactDOM.unmountComponentAtNode(document.getElementById('uploadFields'));
                    }
                    
                    this.ConfirmationsModel.GetConfirmationsByTicketId(this.tariff[0].IdTicket,this.Customer.DateOfBirth);
                  }}
                  FalseMaxDateText={Vas.Resources.Labels["DateUnderTime"]} 
                  MaxValue={moment()}
                  
                  /></div>
                <div className={"RightContainer"}>
                  <SelectField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  ref={"gender"}
                  IsRequired={true}
                  Id={"Gender"}
                  //Float={'left'}
                  Label={Vas.Resources.Labels["Gender"]}
                  Data={ this.state.GenderValues }
                  OnChange={()=>{this.Customer.Gender = $("#Gender").val() ;}}
                  Tooltip={Vas.Resources.Tooltips["Gender"]} /></div>
              </td>
            </tr>
            <tr>
              <td colSpan="2">
                <EmailField
                AppURL={Vas.ApplicationUrl}
                me={this}
                Id={"Email"}
                ref={"email"}
                Editable={true}
                IsRequired={true}
                Tooltip={Vas.Resources.Tooltips["Email"]} 
                Label={Vas.Resources.Labels["Email"]}
                //OnChange={()=>{this.setState({ Email: $("#Email").val() }); }}
                ApiUrl={Vas.ApiUrl}
                ApiKey={Vas.ApiKey}
                Token={localStorage.getItem["vas_token"]}
                AnonymousToken={localStorage.getItem["anonymous_token"]}
                OnBlur={()=>{ 
                  this.Customer.Email = $("#Email").val();
                  this.setState({ EmailRepeat: false },()=>{
                  document.getElementById('EmailRepeat').value = '';
                  this.refs.IconMailRepeat.setState({ Name:"",Color:"red" });
                }); }}
                Reference = {this}
                />
              </td>
            </tr>
            <tr>
              <td colSpan="2">
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <div id={"mailRepeat"}>
                        <TextField
                          AppURL={Vas.ApplicationUrl}
                          me={this}
                          ref={"emailRepeat"}
                          Editable={true}
                          IsRequired={true}
                          Id={"EmailRepeat"}
                          Label={Vas.Resources.Labels["EmailRepeat"]}
                          //OnBlur={()=>{ this.checkEmail();}}
                          //OnChange={()=>{ this.setState({ EmailRepeat: $("#EmailRepeat").val() }); }} 
                          OnBlur={()=>{ this.setState({ EmailRepeat: $("#EmailRepeat").val() },()=>{this.checkEmail("Customer");}); }}
                          Tooltip={Vas.Resources.Tooltips["EmailRepeat"]}
                          />
                          </div>
                      </td>
                      <td>
                        <Icon
                          Id={"iconMailRepeat"}
                          ref={"IconMailRepeat"}
                          Name={""}
                          Size={24}
                          Color={"red"}
                          Align={"left"} />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td><TextField
                Modus={"TelNumber"}
                AppURL={Vas.ApplicationUrl}
                me={this}
                Editable={true}
                ref={"phone"}
                Id={"Phone"}
                Label={Vas.Resources.Labels["Phone"]}
                OnChange={()=>{ this.Customer.Phone = $("#Phone").val() ; }} 
                IsRequired={false}
                Tooltip={Vas.Resources.Tooltips["Phone"]}/></td>
            </tr>
          </tbody>
        </table>
      );
    }

    setStepCustomerAdress(){
      return(
        <table style={{ width: '505px'}}>
          <tbody>
          <tr>
            <td colSpan='2'>
              <br /><div className={"ConfirmationLabel"}>{Vas.Resources.Labels["RequiredField"]}</div><br />
            </td>
            <td></td>
          </tr>
            <tr>
              <td colSpan='2'>
                <div className={"LeftContainer"}>
                  <TextField
                  Modus={"Number"}
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  ref={"zip"}
                  Id={"Zip"}
                  IsRequired={true}
                  Editable={true}
                  Label={Vas.Resources.Labels["Zip"]}
                  OnBlur={()=>{ 

                    if ($("#Zip").val().length === 5){
                      this.Customer.PostCode = $("#Zip").val() ; 
                    } else {
                      $("#Zip").val('');
                      ReactDOM.render(<MessageBox 
                        Message={Vas.Resources.Labels["PLZNote"]} 
                        Title={Vas.Resources.Titles["Note"]}
                        Field={"Zip"} />
                          ,document.getElementById('messageContainer'));
                    }
                  }} 
                  Tooltip={Vas.Resources.Tooltips["Zip"]}
                  
                  /></div>
                  <div className={"RightContainer"}>
                    <TextField
                    AppURL={Vas.ApplicationUrl}
                    me={this}
                    ref={"city"}
                    Id={"City"}
                    IsRequired={true}
                    Editable={true}
                    Label={Vas.Resources.Labels["Place"]}
                    OnChange={()=>{ this.Customer.City = $("#City").val() ; }}
                    OnBlur={()=>{this.getStreets("Customer");}} 
                    Tooltip={Vas.Resources.Tooltips["Place"]}/></div>
                </td>
            </tr>
            <tr>
              <td colSpan={2}><AutocompleteField
                AppURL={Vas.ApplicationUrl}
                TitleMessageFalseStreet={Vas.Resources.Labels["Error"]}
                MessageFalseStreet={Vas.Resources.Labels["FalseStreet"]}
                me={this}
                Width={346}
                Modus={"Street"}
                IsRequired={true}
                ref={"street"}
                Id={"Street"}
                Float={'left'}
                editable={true}
                Label={Vas.Resources.Labels["Street"]}
                Data={this.state.streets}
                OnBlur={()=>{ this.Customer.Street = $("#Street").val();}}
                Tooltip={Vas.Resources.Tooltips["Street"]}
                TimeOutTime={Vas.TimeOutTime} /></td>
            </tr>
            <tr>
              <td colSpan='2'>
                <div className={"LeftContainer"}>
                  <TextField
                  Modus={"Number"}
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  Editable={true}
                  ref={"houseNumber"}
                  IsRequired={true}
                  Id={"HouseNumber"}
                  Label={Vas.Resources.Labels["HouseNumber"]}
                  OnChange={()=>{
                    this.Customer.HouseNumber = $("#HouseNumber").val() ; 
                  }}
                  Tooltip={Vas.Resources.Tooltips["Housenumber"]} /></div>
                <div className={"RightContainer"}>
                  <TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  Editable={true}
                  ref={"houseNumberAddition"}
                  Id={"HouseNumberAddition"}
                  Label={Vas.Resources.Labels["HouseNumberAddition"]}
                  OnChange={()=>{ this.Customer.HouseNumberAddition = $("#HouseNumberAddition").val() ; }}
                  Tooltip={Vas.Resources.Tooltips["HouseNumberAddition"]} /></div>
              </td>
            </tr>
            <tr>
              <td colSpan={2}><TextField
                AppURL={Vas.ApplicationUrl}
                me={this}
                Editable={true}
                Width={346}
                ref={"adressAddition"}
                Id={"AddressAddition"}
                Label={Vas.Resources.Labels["AdditionAdress"]}
                OnChange={()=>{ this.Customer.Name3 = $("#AddressAddition").val() ; }}
                Tooltip={Vas.Resources.Tooltips["AddressAddition"]} /></td>
            </tr>
          </tbody>
        </table>
      );
    }

    checkOfAge(date){
        let today = moment();
        let newDate = DateTimeHelper.StringToDate(date,false,localStorage.getItem('vas_language'));
        let jahre = today.year() - newDate.year();
        if ((today.month() - newDate.month()) < 0){
            jahre--;
        } else {
            if ((today.month() - newDate.month()) === 0){
                if ((today.date() - newDate.date()) < 0){
                    jahre--;
                }
            }
        }

        let rqFields = this.state.requiredFields;
        let reqCheckBox = this.state.requiredCeckBox;

        if (jahre < 18){
            //alert("Die eingegebene Person ist nicht volljährig")
            
            rqFields = this.changeRequiredFieldsIndex(rqFields,false,this.state.ConfirmationsRequired);
            reqCheckBox = this.changeRequiredFieldsIndex(reqCheckBox,false,this.state.ConfirmationsRequired);

            /*let idxEmail = -1;
            for(let i = 0; i< rqFields.length; i++){
              if(rqFields[i].Key.props.Id === this.refs.email.props.Id){
                idxEmail = i;
              }
            }
            
            if(idxEmail > -1){
              rqFields.splice(idxEmail,1);
            }
      
            let idxSternEmail = this.refs.email.state.Label.indexOf('*');
            if(idxSternEmail > -1){
              this.refs.email.setState({Label:this.refs.email.state.Label.replace('*',Vas.Resources.Labels["VoluntaryDisclosure"]), isrequired:false});
            }

            let idxEmailRepeat = -1;
            for(let i = 0; i< rqFields.length; i++){
              if(rqFields[i].Key.props.Id === this.refs.emailRepeat.props.Id){
                idxEmailRepeat = i;
              }
            }
            if(idxEmailRepeat > -1){
              rqFields.splice(idxEmailRepeat,1);
            }

            let idxSternEmailRepeat = this.refs.emailRepeat.state.Label.indexOf('*');
            if(idxSternEmailRepeat > -1){
              this.refs.emailRepeat.setState({Label:this.refs.emailRepeat.state.Label.replace('*',Vas.Resources.Labels["VoluntaryDisclosure"]), isrequired:false});
            }*/
            this.setState({CustomerOfAge : false, requiredFields:rqFields , requiredCeckBox : reqCheckBox},()=>{
              this.jump(1,1);
            });
            //return false;
        } else {
            //alert("Die eingegebene Person ist volljährig")
            //return true;
            rqFields = this.changeRequiredFieldsIndex(rqFields,true,this.state.ConfirmationsRequired);
            reqCheckBox = this.changeRequiredFieldsIndex(reqCheckBox,true,this.state.ConfirmationsRequired);

            this.LegalGuardien = new Customer();

            /*let idxEmail = -1;
            for(let i = 0; i< rqFields.length; i++){
              if(rqFields[i].Key.props.Id === this.refs.email.props.Id){
                idxEmail = i;
              }
            }
            if(idxEmail === -1){
              rqFields.push({Key:this.refs.email,Index:5,Step:1});
            }

            let idxSternEmail = this.refs.email.state.Label.indexOf(Vas.Resources.Labels["VoluntaryDisclosure"]);
            if(idxSternEmail > -1){
              this.refs.email.setState({Label:this.refs.email.state.Label.replace(Vas.Resources.Labels["VoluntaryDisclosure"],"*"), isrequired:true});
            }

            let idxEmailRepeat = -1;
            for(let i = 0; i< rqFields.length; i++){
              if(rqFields[i].Key.props.Id === this.refs.emailRepeat.props.Id){
                idxEmailRepeat = i;
              }
            }
            if(idxEmailRepeat === -1){
              rqFields.push({Key:this.refs.emailRepeat,Index:6,Step:1});
            }

            let idxSternEmailRepeat = this.refs.emailRepeat.state.Label.indexOf(Vas.Resources.Labels["VoluntaryDisclosure"]);
            if(idxSternEmailRepeat > -1){
              this.refs.emailRepeat.setState({Label:this.refs.emailRepeat.state.Label.replace(Vas.Resources.Labels["VoluntaryDisclosure"],'*'), isrequired:true});
            }*/

            this.setState({CustomerOfAge : true, requiredFields:rqFields, requiredCeckBox : reqCheckBox});
        }
    }

    buildStepperTable(number,title,content,buttonContinue,buttonBack,buttonOrder){
      let btoContinue = '';
      if (buttonContinue === true){
        btoContinue = (<ExtendedButton
          Id={"buttonContinue" + number}
          Usable={true}
          Text={Vas.Resources.Labels["Continue"]}
          Float={"left"}
          Width={180}
          OnClick={() => { this.jump((number +1), number.toString()); }} />);
      }

      let btoBack = '';
      if (buttonBack === true){

        if(number === 1) {
          btoBack = (<ExtendedButton
            Id={"buttonBack"+ number}
            Usable={true}
            Text={Vas.Resources.Labels["Back"]}
            Width={180}
            Float={"left"}
            OnClick={()=>{ localStorage.setItem("ContractData",JSON.stringify([this.Customer,this.LegalGuardien,this.AccountOwner,this.Payment]));Vas.GetView("Tariffing",{ BackButton: 'Back' },false);}} />);
        } else {
          btoBack = (<ExtendedButton
            Id={"buttonBack"+ number}
            Usable={true}
            Text={Vas.Resources.Labels["Back"]}
            Width={180}
            Float={"left"}
            OnClick={() => { this.jump((number -1), number.toString()); }} />);
        }
      }

      let btoOrder = '';
      if (buttonOrder === true){
        btoOrder = (<ExtendedButton
          ref={"Order"}
          Usable={true}
          Text={Vas.Resources.Labels["OrderCosts"]}
          OnClick={() => { this.Order(); }}
          Float={"left"}
          Width={180}
          Id={"btoOrder"} />);
      }
      return (<table
        id={"StepperTable_" +title}
        className={"StepperTable"}>
        <tbody>
          <tr onClick={() => { this.jump(number.toString()); }}>
            <td><div
              id={"i" + number.toString()}
              className={"StepperIcon"} >{number}</div></td>
            <td><div className={"StepperLabel"}>{title}</div></td>
          </tr>
          <tr
            id={number.toString()}
            className={"c"} 
            style={{ display: 'none' }}>
            <td className={"StepperConnector"}></td>
            <td>
              {content}
              <br />
              <br />
              {btoBack}
              {btoContinue}
              {btoOrder}
            </td>
          </tr>
        </tbody>
      </table>);
    }

    buildStepperTableNotVisible(name,title,content){
      return (<table
        id={"StepperTable_" + name}
        className={"StepperTable"}
        style={{ display: 'none' }}>
        <tbody>
          <tr>
            <td></td>
            <td><div className={"StepperLabel"}>{title}</div></td>
          </tr>
          <tr>
            <td className={"StepperConnector"}></td>
            <td>
              {content}
            </td>
          </tr>
        </tbody>
      </table>);
    }

    //#endregion
    
    LogoClick(){

      var kontrastNumber = localStorage.getItem('Kontrast');
  
      if(kontrastNumber == "true"){
        $(".orderPopUpForm .StepperIconActive").attr('style', 'background-color: #1d5c87;');
        $('.orderPopUpForm .StepperIcon').attr('style', 'background-color: none;');
        $('.orderPopUpForm').attr('style', 'border: 1px solid #1d5c87;');
        $('.orderPopUpForm #buttonContinue1').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');
        $('.orderPopUpForm #buttonBack1').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');

        $('.orderPopUpForm .selectField').attr('style', 'border-bottom: 1px dotted #1d5c87;');

        $('.orderPopUpForm .selectField #TariffProducts').attr('style', 'width: 350px; border-bottom: 1px dotted #1d5c87;');
        $('.orderPopUpForm #ContractStart').attr('style', 'width: 210px; border-bottom: 1px dotted #1d5c87;');
        $('.orderPopUpForm #Via').attr('style', 'border-bottom: 1px dotted #1d5c87;');
        $('.orderPopUpForm #ContractEnd').attr('style', 'border-bottom: 1px dotted #1d5c87;');
        $('.orderPopUpForm #PaymentTerms').attr('style', 'width: 170px; float: left; background-color: #1d5c87;');
        $('.orderPopUpForm #buttonBack2').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');
        $('.orderPopUpForm #buttonContinue2').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');
        $('.orderPopUpForm #TariffProduct_ButtonBack').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');
        $('.orderPopUpForm #Payment_ButtonBack').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');
        $('.orderPopUpForm #buttonBack3').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');
        $('.orderPopUpForm #buttonContinue3').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');
        $('.orderPopUpForm #btoChoose').attr('style', 'width: 170px; background-color: #1d5c87;');
        $('.orderPopUpForm #DownloadDocument').attr('style', 'width: 170px; background-color: #1d5c87;');
        $('.orderPopUpForm #UploasdCertificateButton').attr('style', 'width: 170px; float: left; background-color: #1d5c87;');
        $('.orderPopUpForm #text').attr('style', 'width: 220px; background-color: #1d5c87;');
        $('.orderPopUpForm #FileText').attr('style', 'width: 170px; background-color: #1d5c87;');
        $('.orderPopUpForm #btoChoose_1').attr('style', 'width: 150px; float: left; background-color: #1d5c87;');
        $('.orderPopUpForm #btoChoose_2').attr('style', 'width: 150px; float: left; background-color: #1d5c87;');
        $('.orderPopUpForm #btoChoose_3').attr('style', 'width: 150px; float: left; background-color: #1d5c87;');
        $('.orderPopUpForm #btoChoose_4').attr('style', 'width: 150px; float: left; background-color: #1d5c87;');
        $('.orderPopUpForm #buttonContinue4').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');
        $('.orderPopUpForm #buttonBack4').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');
        $('.orderPopUpForm #buttonContinue5').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');
        $('.orderPopUpForm #buttonBack5').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');
        $('.orderPopUpForm #buttonContinue6').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');
        $('.orderPopUpForm #ContractData_ButtonBack').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');
        $('.orderPopUpForm #AddressDataAccountOwner_ButtonBack').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');

        $('.orderPopUpForm #PersonalData_ButtonBack').attr('style', 'width: 400px; float: left; background-color: #1d5c87;');
        $('.orderPopUpForm #AddressData_ButtonBack').attr('style', 'width: 400px; float: left; background-color: #1d5c87;');

        $('.orderPopUpForm #PersonalDataLegalGuardian_ButtonBack').attr('style', 'width: 430px; float: left; background-color: #1d5c87;');
        $('.orderPopUpForm #AddressDataLegalGuardian_ButtonBack').attr('style', 'width: 420px; float: left; background-color: #1d5c87;');

        $('.orderPopUpForm #PaymentData_ButtonBack').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');
        $('.orderPopUpForm #btoOrder').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');
        $('.orderPopUpForm #buttonBack6').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');
        
        $(".orderPopUpForm #btoChoose_1, .orderPopUpForm #btoChoose_2, .orderPopUpForm #btoChoose_3, .orderPopUpForm #btoChoose_4").mouseenter(function() {
            $(this).attr('style', 'background-color: #00375b; width: 150px; float: left;');
        }).mouseleave(function() {
            $(this).attr('style', 'background-color: #1d5c87; width: 150px; float: left;');
        });

        $(".orderPopUpForm #PaymentTerms").mouseenter(function() {
            $(this).attr('style', 'background-color: #00375b; width: 170px; float: left;');
        }).mouseleave(function() {
            $(this).attr('style', 'background-color: #1d5c87; width: 170px; float: left;');
        });

        $(".orderPopUpForm #buttonBack1, .orderPopUpForm #buttonContinue1," +
         ".orderPopUpForm #buttonBack2, .orderPopUpForm #buttonContinue2," +
         ".orderPopUpForm #buttonBack3, .orderPopUpForm #buttonContinue3," +
         ".orderPopUpForm #buttonBack4, .orderPopUpForm #buttonContinue4," +
         ".orderPopUpForm #buttonBack5, .orderPopUpForm #buttonContinue5," + 
         ".orderPopUpForm #buttonBack6, .orderPopUpForm #btoOrder," +
         ".orderPopUpForm #ContractData_ButtonBack, .orderPopUpForm #PaymentData_ButtonBack, .orderPopUpForm #AddressDataAccountOwner_ButtonBack").mouseenter(function() {
            $(this).attr('style', 'background-color: #00375b; width: 180px; float: left;');
        }).mouseleave(function() {
            $(this).attr('style', 'background-color: #1d5c87; width: 180px; float: left;');
        });

        $(".orderPopUpForm #PersonalData_ButtonBack, .orderPopUpForm #AddressData_ButtonBack").mouseenter(function() {
            $(this).attr('style', 'background-color: #00375b; width: 400px; float: left;');
        }).mouseleave(function() {
            $(this).attr('style', 'background-color: #1d5c87; width: 400px; float: left;');
        });

        $(".orderPopUpForm #PersonalDataLegalGuardian_ButtonBack").mouseenter(function() {
            $(this).attr('style', 'background-color: #00375b; width: 430px; float: left;');
        }).mouseleave(function() {
            $(this).attr('style', 'background-color: #1d5c87; width: 430px; float: left;');
        });

        $(".orderPopUpForm #AddressDataLegalGuardian_ButtonBack").mouseenter(function() {
            $(this).attr('style', 'background-color: #00375b; width: 420px; float: left;');
        }).mouseleave(function() {
            $(this).attr('style', 'background-color: #1d5c87; width: 420px; float: left;');
        });

        $(".autocomplete-active").attr('style', 'background-color: #00375b !important;');

      }
    }

    FontSizeClick(condition){
      var schriftgröße = localStorage.getItem('Schriftgröße');

      //Schriftgröße bei Klick in 2er Schritten erhöhen

        if(schriftgröße != null){
            if(condition){

                switch(schriftgröße){
                    case "0":
                      $("#GenderAccountOwnerLabel").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#GenderAccountOwner").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#ZipAccountOwnerLabel").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#ZipAccountOwner").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#CityAccountOwnerLabel").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#CityAccountOwner").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#StreetAccountOwnerLabel").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#StreetAccountOwner").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#HouseNumberAccountOwnerLabel").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#HouseNumberAccountOwner").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#HouseNumberAdditionAccountOwnerLabel").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#HouseNumberAdditionAccountOwner").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#AddressAdditionAccountOwnerLabel").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#AddressAdditionAccountOwner").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");

                      $("#AddressDataAccountOwner_GenderHeadline").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#AddressDataAccountOwner_Gender").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#AddressDataAccountOwner_ZipHeadline").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#AddressDataAccountOwner_Zip").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#AddressDataAccountOwner_PlaceHeadline").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#AddressDataAccountOwner_Place").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#AddressDataAccountOwner_StreetHeadline").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#AddressDataAccountOwner_Street").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#AddressDataAccountOwner_HouseNumberHeadline").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#AddressDataAccountOwner_HouseNumber").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#AddressDataAccountOwner_HouseNumberAdditionHeadline").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#AddressDataAccountOwner_HouseNumberAddition").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#AddressDataAccountOwner_AddressAdditionHeadline").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#AddressDataAccountOwner_AddressAddition").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");

                      $('.orderPopUpForm #AddressDataAccountOwner_ButtonBack').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#bic").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#nameOfBank").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");

                      $("#Text").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#FileText").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#btoChoose").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#btoChoose_1").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#btoChoose_2").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#btoChoose_3").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#btoChoose_4").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#DownloadDocument").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#UploasdCertificateButton").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#buttonBack4").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#buttonContinue4").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $(".orderPopUpForm .ConfirmationLabel").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      
                      localStorage.setItem('Schriftgröße', '1');

                    break;
                    case "1":
                      $("#GenderAccountOwnerLabel").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#GenderAccountOwner").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#ZipAccountOwnerLabel").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#ZipAccountOwner").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#CityAccountOwnerLabel").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#CityAccountOwner").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#StreetAccountOwnerLabel").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#StreetAccountOwner").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#HouseNumberAccountOwnerLabel").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#HouseNumberAccountOwner").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#HouseNumberAdditionAccountOwnerLabel").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#HouseNumberAdditionAccountOwner").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#AddressAdditionAccountOwnerLabel").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#AddressAdditionAccountOwner").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");

                      $("#AddressDataAccountOwner_GenderHeadline").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#AddressDataAccountOwner_Gender").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#AddressDataAccountOwner_ZipHeadline").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#AddressDataAccountOwner_Zip").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#AddressDataAccountOwner_PlaceHeadline").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#AddressDataAccountOwner_Place").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#AddressDataAccountOwner_StreetHeadline").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#AddressDataAccountOwner_Street").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#AddressDataAccountOwner_HouseNumberHeadline").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#AddressDataAccountOwner_HouseNumber").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#AddressDataAccountOwner_HouseNumberAdditionHeadline").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#AddressDataAccountOwner_HouseNumberAddition").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#AddressDataAccountOwner_AddressAdditionHeadline").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#AddressDataAccountOwner_AddressAddition").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");

                      $('.orderPopUpForm #AddressDataAccountOwner_ButtonBack').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#bic").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#nameOfBank").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");

                      $("#Text").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#FileText").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#btoChoose").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#btoChoose_1").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#btoChoose_2").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#btoChoose_3").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#btoChoose_4").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#DownloadDocument").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#UploasdCertificateButton").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#buttonBack4").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#buttonContinue4").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $(".orderPopUpForm .ConfirmationLabel").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                        
                      localStorage.setItem('Schriftgröße', '2');
                    break;
                    case "2":
                      $("#GenderAccountOwnerLabel").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#GenderAccountOwner").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#ZipAccountOwnerLabel").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#ZipAccountOwner").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#CityAccountOwnerLabel").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#CityAccountOwner").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#StreetAccountOwnerLabel").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#StreetAccountOwner").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#HouseNumberAccountOwnerLabel").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#HouseNumberAccountOwner").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#HouseNumberAdditionAccountOwnerLabel").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#HouseNumberAdditionAccountOwner").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#AddressAdditionAccountOwnerLabel").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#AddressAdditionAccountOwner").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                      $("#AddressDataAccountOwner_GenderHeadline").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#AddressDataAccountOwner_Gender").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#AddressDataAccountOwner_ZipHeadline").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#AddressDataAccountOwner_Zip").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#AddressDataAccountOwner_PlaceHeadline").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#AddressDataAccountOwner_Place").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#AddressDataAccountOwner_StreetHeadline").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#AddressDataAccountOwner_Street").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#AddressDataAccountOwner_HouseNumberHeadline").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#AddressDataAccountOwner_HouseNumber").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#AddressDataAccountOwner_HouseNumberAdditionHeadline").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#AddressDataAccountOwner_HouseNumberAddition").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#AddressDataAccountOwner_AddressAdditionHeadline").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#AddressDataAccountOwner_AddressAddition").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                      $('.orderPopUpForm #AddressDataAccountOwner_ButtonBack').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#bic").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#nameOfBank").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                      $("#Text").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#FileText").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#btoChoose").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#btoChoose_1").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#btoChoose_2").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#btoChoose_3").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#btoChoose_4").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#DownloadDocument").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#UploasdCertificateButton").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#buttonBack4").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#buttonContinue4").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $(".orderPopUpForm .ConfirmationLabel").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                      localStorage.setItem('Schriftgröße', '3');
                    break;
                    case "3":
                      $("#GenderAccountOwnerLabel").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#GenderAccountOwner").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#ZipAccountOwnerLabel").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#ZipAccountOwner").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#CityAccountOwnerLabel").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#CityAccountOwner").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#StreetAccountOwnerLabel").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#StreetAccountOwner").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#HouseNumberAccountOwnerLabel").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#HouseNumberAccountOwner").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#HouseNumberAdditionAccountOwnerLabel").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#HouseNumberAdditionAccountOwner").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#AddressAdditionAccountOwnerLabel").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#AddressAdditionAccountOwner").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");

                      $("#AddressDataAccountOwner_GenderHeadline").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#AddressDataAccountOwner_Gender").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#AddressDataAccountOwner_ZipHeadline").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#AddressDataAccountOwner_Zip").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#AddressDataAccountOwner_PlaceHeadline").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#AddressDataAccountOwner_Place").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#AddressDataAccountOwner_StreetHeadline").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#AddressDataAccountOwner_Street").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#AddressDataAccountOwner_HouseNumberHeadline").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#AddressDataAccountOwner_HouseNumber").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#AddressDataAccountOwner_HouseNumberAdditionHeadline").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#AddressDataAccountOwner_HouseNumberAddition").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#AddressDataAccountOwner_AddressAdditionHeadline").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#AddressDataAccountOwner_AddressAddition").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");

                      $('.orderPopUpForm #AddressDataAccountOwner_ButtonBack').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#bic").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#nameOfBank").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");

                      $("#Text").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#FileText").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#btoChoose").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#btoChoose_1").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#btoChoose_2").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#btoChoose_3").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#btoChoose_4").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#DownloadDocument").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#UploasdCertificateButton").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#buttonBack4").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#buttonContinue4").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $(".orderPopUpForm .ConfirmationLabel").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");

                      localStorage.setItem('Schriftgröße', '4');
                    break;
                    case "4":
                      $("#GenderAccountOwnerLabel").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#GenderAccountOwner").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#ZipAccountOwnerLabel").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#ZipAccountOwner").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#CityAccountOwnerLabel").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#CityAccountOwner").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#StreetAccountOwnerLabel").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#StreetAccountOwner").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#HouseNumberAccountOwnerLabel").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#HouseNumberAccountOwner").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#HouseNumberAdditionAccountOwnerLabel").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#HouseNumberAdditionAccountOwner").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#AddressAdditionAccountOwnerLabel").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#AddressAdditionAccountOwner").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");

                      $("#AddressDataAccountOwner_GenderHeadline").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#AddressDataAccountOwner_Gender").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#AddressDataAccountOwner_ZipHeadline").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#AddressDataAccountOwner_Zip").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#AddressDataAccountOwner_PlaceHeadline").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#AddressDataAccountOwner_Place").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#AddressDataAccountOwner_StreetHeadline").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#AddressDataAccountOwner_Street").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#AddressDataAccountOwner_HouseNumberHeadline").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#AddressDataAccountOwner_HouseNumber").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#AddressDataAccountOwner_HouseNumberAdditionHeadline").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#AddressDataAccountOwner_HouseNumberAddition").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#AddressDataAccountOwner_AddressAdditionHeadline").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#AddressDataAccountOwner_AddressAddition").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");

                      $('.orderPopUpForm #AddressDataAccountOwner_ButtonBack').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#bic").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#nameOfBank").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");

                      $("#Text").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#FileText").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#btoChoose").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#btoChoose_1").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#btoChoose_2").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#btoChoose_3").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#btoChoose_4").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#DownloadDocument").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#UploasdCertificateButton").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#buttonBack4").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#buttonContinue4").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $(".orderPopUpForm .ConfirmationLabel").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                                    
                      localStorage.setItem('Schriftgröße', '5');
                    break;
                    case "5":
                      $("#GenderAccountOwnerLabel").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#GenderAccountOwner").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#ZipAccountOwnerLabel").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#ZipAccountOwner").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#CityAccountOwnerLabel").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#CityAccountOwner").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#StreetAccountOwnerLabel").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#StreetAccountOwner").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#HouseNumberAccountOwnerLabel").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#HouseNumberAccountOwner").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#HouseNumberAdditionAccountOwnerLabel").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#HouseNumberAdditionAccountOwner").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#AddressAdditionAccountOwnerLabel").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#AddressAdditionAccountOwner").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                      $("#AddressDataAccountOwner_GenderHeadline").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#AddressDataAccountOwner_Gender").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#AddressDataAccountOwner_ZipHeadline").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#AddressDataAccountOwner_Zip").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#AddressDataAccountOwner_PlaceHeadline").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#AddressDataAccountOwner_Place").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#AddressDataAccountOwner_StreetHeadline").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#AddressDataAccountOwner_Street").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#AddressDataAccountOwner_HouseNumberHeadline").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#AddressDataAccountOwner_HouseNumber").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#AddressDataAccountOwner_HouseNumberAdditionHeadline").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#AddressDataAccountOwner_HouseNumberAddition").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#AddressDataAccountOwner_AddressAdditionHeadline").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#AddressDataAccountOwner_AddressAddition").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                      $('.orderPopUpForm #AddressDataAccountOwner_ButtonBack').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#bic").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#nameOfBank").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                      $("#Text").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#FileText").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#btoChoose").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#btoChoose_1").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#btoChoose_2").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#btoChoose_3").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#btoChoose_4").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#DownloadDocument").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#UploasdCertificateButton").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#buttonBack4").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#buttonContinue4").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $(".orderPopUpForm .ConfirmationLabel").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                      localStorage.setItem('Schriftgröße', '0');
                    break;
                }

            } else {
              switch(schriftgröße){
                case "0":
                  $("#GenderAccountOwnerLabel").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                  $("#GenderAccountOwner").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#ZipAccountOwnerLabel").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#ZipAccountOwner").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#CityAccountOwnerLabel").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#CityAccountOwner").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#StreetAccountOwnerLabel").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#StreetAccountOwner").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#HouseNumberAccountOwnerLabel").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#HouseNumberAccountOwner").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#HouseNumberAdditionAccountOwnerLabel").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#HouseNumberAdditionAccountOwner").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#AddressAdditionAccountOwnerLabel").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#AddressAdditionAccountOwner").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                      $("#AddressDataAccountOwner_GenderHeadline").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#AddressDataAccountOwner_Gender").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#AddressDataAccountOwner_ZipHeadline").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#AddressDataAccountOwner_Zip").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#AddressDataAccountOwner_PlaceHeadline").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#AddressDataAccountOwner_Place").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#AddressDataAccountOwner_StreetHeadline").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#AddressDataAccountOwner_Street").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#AddressDataAccountOwner_HouseNumberHeadline").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#AddressDataAccountOwner_HouseNumber").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#AddressDataAccountOwner_HouseNumberAdditionHeadline").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#AddressDataAccountOwner_HouseNumberAddition").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#AddressDataAccountOwner_AddressAdditionHeadline").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#AddressDataAccountOwner_AddressAddition").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                      $('.orderPopUpForm #AddressDataAccountOwner_ButtonBack').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#bic").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#nameOfBank").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                      $("#Text").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#FileText").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#btoChoose").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#btoChoose_1").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#btoChoose_2").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#btoChoose_3").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#btoChoose_4").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#DownloadDocument").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#UploasdCertificateButton").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#buttonBack4").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#buttonContinue4").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $(".orderPopUpForm .ConfirmationLabel").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                break;
                case "1":              
                $("#GenderAccountOwnerLabel").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                $("#GenderAccountOwner").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                $("#ZipAccountOwnerLabel").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                $("#ZipAccountOwner").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                $("#CityAccountOwnerLabel").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                $("#CityAccountOwner").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                $("#StreetAccountOwnerLabel").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                $("#StreetAccountOwner").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                $("#HouseNumberAccountOwnerLabel").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                $("#HouseNumberAccountOwner").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                $("#HouseNumberAdditionAccountOwnerLabel").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                $("#HouseNumberAdditionAccountOwner").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                $("#AddressAdditionAccountOwnerLabel").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                $("#AddressAdditionAccountOwner").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");

                $("#AddressDataAccountOwner_GenderHeadline").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#AddressDataAccountOwner_Gender").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#AddressDataAccountOwner_ZipHeadline").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#AddressDataAccountOwner_Zip").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#AddressDataAccountOwner_PlaceHeadline").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#AddressDataAccountOwner_Place").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#AddressDataAccountOwner_StreetHeadline").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#AddressDataAccountOwner_Street").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#AddressDataAccountOwner_HouseNumberHeadline").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#AddressDataAccountOwner_HouseNumber").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#AddressDataAccountOwner_HouseNumberAdditionHeadline").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#AddressDataAccountOwner_HouseNumberAddition").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#AddressDataAccountOwner_AddressAdditionHeadline").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#AddressDataAccountOwner_AddressAddition").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");

                      $('.orderPopUpForm #AddressDataAccountOwner_ButtonBack').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#bic").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#nameOfBank").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");

                      $("#Text").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#FileText").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#btoChoose").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#btoChoose_1").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#btoChoose_2").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#btoChoose_3").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#btoChoose_4").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#DownloadDocument").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#UploasdCertificateButton").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#buttonBack4").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#buttonContinue4").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $(".orderPopUpForm .ConfirmationLabel").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                     
                break;
                case "2":
                  $("#GenderAccountOwnerLabel").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                  $("#GenderAccountOwner").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#ZipAccountOwnerLabel").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#ZipAccountOwner").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#CityAccountOwnerLabel").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#CityAccountOwner").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#StreetAccountOwnerLabel").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#StreetAccountOwner").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#HouseNumberAccountOwnerLabel").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#HouseNumberAccountOwner").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#HouseNumberAdditionAccountOwnerLabel").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#HouseNumberAdditionAccountOwner").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#AddressAdditionAccountOwnerLabel").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#AddressAdditionAccountOwner").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");

                      $("#AddressDataAccountOwner_GenderHeadline").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#AddressDataAccountOwner_Gender").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#AddressDataAccountOwner_ZipHeadline").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#AddressDataAccountOwner_Zip").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#AddressDataAccountOwner_PlaceHeadline").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#AddressDataAccountOwner_Place").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#AddressDataAccountOwner_StreetHeadline").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#AddressDataAccountOwner_Street").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#AddressDataAccountOwner_HouseNumberHeadline").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#AddressDataAccountOwner_HouseNumber").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#AddressDataAccountOwner_HouseNumberAdditionHeadline").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#AddressDataAccountOwner_HouseNumberAddition").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#AddressDataAccountOwner_AddressAdditionHeadline").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#AddressDataAccountOwner_AddressAddition").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");

                      $('.orderPopUpForm #AddressDataAccountOwner_ButtonBack').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#bic").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#nameOfBank").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");

                      $("#Text").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#FileText").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#btoChoose").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#btoChoose_1").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#btoChoose_2").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#btoChoose_3").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#btoChoose_4").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#DownloadDocument").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#UploasdCertificateButton").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#buttonBack4").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#buttonContinue4").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $(".orderPopUpForm .ConfirmationLabel").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");

                break;
                case "3":
                  $("#GenderAccountOwnerLabel").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                  $("#GenderAccountOwner").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#ZipAccountOwnerLabel").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#ZipAccountOwner").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#CityAccountOwnerLabel").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#CityAccountOwner").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#StreetAccountOwnerLabel").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#StreetAccountOwner").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#HouseNumberAccountOwnerLabel").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#HouseNumberAccountOwner").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#HouseNumberAdditionAccountOwnerLabel").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#HouseNumberAdditionAccountOwner").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#AddressAdditionAccountOwnerLabel").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#AddressAdditionAccountOwner").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                      $("#AddressDataAccountOwner_GenderHeadline").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#AddressDataAccountOwner_Gender").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#AddressDataAccountOwner_ZipHeadline").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#AddressDataAccountOwner_Zip").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#AddressDataAccountOwner_PlaceHeadline").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#AddressDataAccountOwner_Place").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#AddressDataAccountOwner_StreetHeadline").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#AddressDataAccountOwner_Street").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#AddressDataAccountOwner_HouseNumberHeadline").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#AddressDataAccountOwner_HouseNumber").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#AddressDataAccountOwner_HouseNumberAdditionHeadline").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#AddressDataAccountOwner_HouseNumberAddition").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#AddressDataAccountOwner_AddressAdditionHeadline").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#AddressDataAccountOwner_AddressAddition").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                      $('.orderPopUpForm #AddressDataAccountOwner_ButtonBack').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#bic").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#nameOfBank").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                      $("#Text").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#FileText").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#btoChoose").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#btoChoose_1").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#btoChoose_2").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#btoChoose_3").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#btoChoose_4").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#DownloadDocument").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#UploasdCertificateButton").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#buttonBack4").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#buttonContinue4").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $(".orderPopUpForm .ConfirmationLabel").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                break;
                case "4":             
                $("#GenderAccountOwnerLabel").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                  $("#GenderAccountOwner").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#ZipAccountOwnerLabel").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#ZipAccountOwner").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#CityAccountOwnerLabel").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#CityAccountOwner").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#StreetAccountOwnerLabel").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#StreetAccountOwner").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#HouseNumberAccountOwnerLabel").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#HouseNumberAccountOwner").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#HouseNumberAdditionAccountOwnerLabel").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#HouseNumberAdditionAccountOwner").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#AddressAdditionAccountOwnerLabel").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#AddressAdditionAccountOwner").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");

                      $("#AddressDataAccountOwner_GenderHeadline").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#AddressDataAccountOwner_Gender").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#AddressDataAccountOwner_ZipHeadline").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#AddressDataAccountOwner_Zip").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#AddressDataAccountOwner_PlaceHeadline").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#AddressDataAccountOwner_Place").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#AddressDataAccountOwner_StreetHeadline").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#AddressDataAccountOwner_Street").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#AddressDataAccountOwner_HouseNumberHeadline").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#AddressDataAccountOwner_HouseNumber").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#AddressDataAccountOwner_HouseNumberAdditionHeadline").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#AddressDataAccountOwner_HouseNumberAddition").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#AddressDataAccountOwner_AddressAdditionHeadline").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#AddressDataAccountOwner_AddressAddition").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");

                      $('.orderPopUpForm #AddressDataAccountOwner_ButtonBack').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#bic").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#nameOfBank").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");

                      $("#Text").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#FileText").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#btoChoose").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#btoChoose_1").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#btoChoose_2").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#btoChoose_3").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#btoChoose_4").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#DownloadDocument").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#UploasdCertificateButton").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#buttonBack4").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#buttonContinue4").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $(".orderPopUpForm .ConfirmationLabel").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");

                break;
                case "5":
                  $("#GenderAccountOwnerLabel").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                  $("#GenderAccountOwner").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#ZipAccountOwnerLabel").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#ZipAccountOwner").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#CityAccountOwnerLabel").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#CityAccountOwner").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#StreetAccountOwnerLabel").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#StreetAccountOwner").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#HouseNumberAccountOwnerLabel").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#HouseNumberAccountOwner").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#HouseNumberAdditionAccountOwnerLabel").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#HouseNumberAdditionAccountOwner").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#AddressAdditionAccountOwnerLabel").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#AddressAdditionAccountOwner").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");

                      $("#AddressDataAccountOwner_GenderHeadline").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#AddressDataAccountOwner_Gender").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#AddressDataAccountOwner_ZipHeadline").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#AddressDataAccountOwner_Zip").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#AddressDataAccountOwner_PlaceHeadline").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#AddressDataAccountOwner_Place").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#AddressDataAccountOwner_StreetHeadline").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#AddressDataAccountOwner_Street").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#AddressDataAccountOwner_HouseNumberHeadline").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#AddressDataAccountOwner_HouseNumber").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#AddressDataAccountOwner_HouseNumberAdditionHeadline").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#AddressDataAccountOwner_HouseNumberAddition").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#AddressDataAccountOwner_AddressAdditionHeadline").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#AddressDataAccountOwner_AddressAddition").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");

                      $('.orderPopUpForm #AddressDataAccountOwner_ButtonBack').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#bic").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#nameOfBank").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");

                      $("#Text").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#FileText").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#btoChoose").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#btoChoose_1").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#btoChoose_2").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#btoChoose_3").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#btoChoose_4").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#DownloadDocument").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#UploasdCertificateButton").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#buttonBack4").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#buttonContinue4").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $(".orderPopUpForm .ConfirmationLabel").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");


                break;
              }
            }
        }
    }

    render()
    {       

        let custPerso = this.setStepCustomerPersonal();
        let personal = this.buildStepperTable(1,Vas.Resources.Labels["PersonalData"] + " " + Vas.Resources.Labels["TicketCustomer"],custPerso,true,true,false);

        let custAdress = this.setStepCustomerAdress();
        let adress = this.buildStepperTable(2,Vas.Resources.Labels["Addressdata"] + " " + Vas.Resources.Labels["TicketCustomer"],custAdress,true,true,false);

        let pay = this.setStepPayment();
        let payment = this.buildStepperTable(3,Vas.Resources.Labels["MethodOfPaymentCustomer"],pay,true,true,false);
        
        let verification = '';
        let legalguardianPersonal = '';
        let legalGuardianAdress = '';
                
        let id = 4;

        let legalPersonal = this.setStepLegalGuardianPersonal();
        let legalAdress = this.setStepLegalGuardianAdress();
        if(this.state.CustomerOfAge === true){
          legalguardianPersonal = this.buildStepperTableNotVisible("LegalGuardianPersonal",Vas.Resources.Labels["PersonalData"] + " " +Vas.Resources.Labels["LegalGuardien"],legalPersonal);
          legalGuardianAdress = this.buildStepperTableNotVisible("LegalGuardianAdress",Vas.Resources.Labels["Addressdata"] + " " + Vas.Resources.Labels["LegalGuardien"],legalAdress);
        }else{
          
          legalguardianPersonal = this.buildStepperTable(id,Vas.Resources.Labels["PersonalData"] + " " +Vas.Resources.Labels["LegalGuardien"],legalPersonal,true,true,false);
          this.stepIdlegalGuardianPersonal = id;
          id++;
          
          legalGuardianAdress = this.buildStepperTable(id,Vas.Resources.Labels["Addressdata"] + " " + Vas.Resources.Labels["LegalGuardien"],legalAdress,true,true,false);
          this.stepIdlegalGuardianAdress = id;
          id++;
        }

        let ver = this.setStepVerifications();
        if(this.state.ConfirmationsRequired === true){
          verification = this.buildStepperTable(id,Vas.Resources.Labels["RequiredCertificates"],ver,true,true,false);
          this.stepIdVerifications = id;
          id++;
        }else{
          verification = this.buildStepperTableNotVisible("Verification",Vas.Resources.Labels["RequiredCertificates"],ver);
        }     

        let orderStep = this.setStepsDataProtectionPaymentOrder(id);

        return ( 
            <div className={"form orderPopUpForm"} style={{width:"1000px", textAlign:"justify"}}>
              <table className={"orderPopUpMainTable"}>
                <thead>
                  <tr>
                    <th>
                      <h2 id="orderNewCustomerHeadline">{Vas.Resources.Labels["Order"]}</h2>
                    </th>
                  </tr>
                  <tr>
                    <th>
                      <div id={"HintMaxAge"} className={"HintRequiredAge"}></div>
                    </th>
                  </tr>
                  <tr>
                    <th>
                      <div id={"HintRequiredAge"} className={"HintRequiredAge"}></div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {personal}
                      {adress}
                      {payment}
                      {legalguardianPersonal}
                      {legalGuardianAdress}
                      {verification}
                      {orderStep}
                    </td>
                  </tr>
                </tbody>
              </table>

            </div>
            
          );
    }
}
export default OrderPopUp;
